const fallbackLanguage = "en";

const SUPPORTED_DISCOVERY_LANGUAGES = [
  "en",
  "es",
  "pt",
  "fr",
  "de",
  "it",
  "zh",
  "ja",
  "ko",
  "ar",
  "hi",
  "ru",
  "tr",
  "nl",
  "pl",
  "id",
];

export const resolveDiscoveryLanguage = (language) => {
  const normalized = String(language || "").toLowerCase().split("-")[0];
  return SUPPORTED_DISCOVERY_LANGUAGES.includes(normalized)
    ? normalized
    : fallbackLanguage;
};

const STEP_KEYS = [
  "organization_type",
  "industry",
  "region",
  "main_needs",
  "solution_type",
  "project_stage",
  "technical_team_status",
  "technical_scope",
  "timeline",
  "investment_range",
  "engagement_type",
  "business_goal_description",
  "contact",
  "summary",
];

const STEP_TITLES = {
  en: [
    "Organization Type",
    "Industry",
    "Project Region",
    "Main Business Need",
    "Type of Solution",
    "Project Stage",
    "Technical Team",
    "Technical Depth",
    "Timeline",
    "Investment Range",
    "Engagement Type",
    "Business Goal",
    "Contact Details",
    "Smart Summary",
  ],
  es: [
    "Tipo de organización",
    "Industria",
    "Región del proyecto",
    "Necesidad principal",
    "Tipo de solución",
    "Etapa del proyecto",
    "Equipo técnico",
    "Profundidad técnica",
    "Plazo",
    "Rango de inversión",
    "Tipo de engagement",
    "Objetivo de negocio",
    "Datos de contacto",
    "Resumen inteligente",
  ],
  pt: [
    "Tipo de organização",
    "Indústria",
    "Região do projeto",
    "Necessidade principal",
    "Tipo de solução",
    "Fase do projeto",
    "Equipe técnica",
    "Profundidade técnica",
    "Prazo",
    "Faixa de investimento",
    "Tipo de contratação",
    "Objetivo de negócio",
    "Dados de contato",
    "Resumo inteligente",
  ],
  fr: [
    "Type d'organisation",
    "Secteur",
    "Région du projet",
    "Besoin principal",
    "Type de solution",
    "Stade du projet",
    "Équipe technique",
    "Profondeur technique",
    "Calendrier",
    "Budget d'investissement",
    "Type d'engagement",
    "Objectif métier",
    "Coordonnées",
    "Résumé intelligent",
  ],
  de: [
    "Organisationstyp",
    "Branche",
    "Projektregion",
    "Wichtigster Bedarf",
    "Lösungstyp",
    "Projektphase",
    "Technisches Team",
    "Technische Tiefe",
    "Zeitplan",
    "Investitionsrahmen",
    "Zusammenarbeitsmodell",
    "Geschäftsziel",
    "Kontaktdaten",
    "Intelligente Zusammenfassung",
  ],
  it: [
    "Tipo di organizzazione",
    "Settore",
    "Regione del progetto",
    "Esigenza principale",
    "Tipo di soluzione",
    "Fase del progetto",
    "Team tecnico",
    "Profondità tecnica",
    "Tempistiche",
    "Fascia di investimento",
    "Tipo di engagement",
    "Obiettivo di business",
    "Dettagli di contatto",
    "Riepilogo intelligente",
  ],
  zh: [
    "组织类型",
    "行业",
    "项目区域",
    "主要业务需求",
    "解决方案类型",
    "项目阶段",
    "技术团队",
    "技术深度",
    "时间规划",
    "投资范围",
    "合作方式",
    "业务目标",
    "联系方式",
    "智能摘要",
  ],
  ja: [
    "組織タイプ",
    "業界",
    "プロジェクト地域",
    "主なビジネス課題",
    "ソリューションの種類",
    "プロジェクト段階",
    "技術チーム",
    "技術的深度",
    "スケジュール",
    "投資レンジ",
    "契約形態",
    "ビジネス目標",
    "連絡先情報",
    "スマート要約",
  ],
  ko: [
    "조직 유형",
    "산업",
    "프로젝트 지역",
    "주요 비즈니스 니즈",
    "솔루션 유형",
    "프로젝트 단계",
    "기술 팀",
    "기술 심화 범위",
    "일정",
    "투자 범위",
    "계약 형태",
    "비즈니스 목표",
    "연락처 정보",
    "스마트 요약",
  ],
  ar: [
    "نوع المؤسسة",
    "القطاع",
    "منطقة المشروع",
    "الاحتياج الرئيسي",
    "نوع الحل",
    "مرحلة المشروع",
    "الفريق التقني",
    "العمق التقني",
    "الجدول الزمني",
    "نطاق الاستثمار",
    "نوع التعاقد",
    "هدف الأعمال",
    "بيانات التواصل",
    "ملخص ذكي",
  ],
  hi: [
    "संगठन का प्रकार",
    "उद्योग",
    "प्रोजेक्ट क्षेत्र",
    "मुख्य व्यावसायिक आवश्यकता",
    "समाधान का प्रकार",
    "प्रोजेक्ट चरण",
    "तकनीकी टीम",
    "तकनीकी गहराई",
    "समय-सीमा",
    "निवेश सीमा",
    "एंगेजमेंट प्रकार",
    "व्यावसायिक लक्ष्य",
    "संपर्क विवरण",
    "स्मार्ट सारांश",
  ],
  ru: [
    "Тип организации",
    "Отрасль",
    "Регион проекта",
    "Основная бизнес-потребность",
    "Тип решения",
    "Стадия проекта",
    "Техническая команда",
    "Техническая глубина",
    "Сроки",
    "Диапазон инвестиций",
    "Формат сотрудничества",
    "Бизнес-цель",
    "Контактные данные",
    "Умное резюме",
  ],
  tr: [
    "Organizasyon türü",
    "Sektör",
    "Proje bölgesi",
    "Temel iş ihtiyacı",
    "Çözüm türü",
    "Proje aşaması",
    "Teknik ekip",
    "Teknik derinlik",
    "Zamanlama",
    "Yatırım aralığı",
    "Çalışma modeli",
    "İş hedefi",
    "İletişim bilgileri",
    "Akıllı özet",
  ],
  nl: [
    "Type organisatie",
    "Sector",
    "Projectregio",
    "Belangrijkste behoefte",
    "Type oplossing",
    "Projectfase",
    "Technisch team",
    "Technische diepgang",
    "Tijdlijn",
    "Investeringsrange",
    "Samenwerkingsvorm",
    "Zakelijk doel",
    "Contactgegevens",
    "Slimme samenvatting",
  ],
  pl: [
    "Typ organizacji",
    "Branża",
    "Region projektu",
    "Główna potrzeba biznesowa",
    "Typ rozwiązania",
    "Etap projektu",
    "Zespół techniczny",
    "Głębokość techniczna",
    "Harmonogram",
    "Zakres inwestycji",
    "Typ współpracy",
    "Cel biznesowy",
    "Dane kontaktowe",
    "Inteligentne podsumowanie",
  ],
  id: [
    "Jenis organisasi",
    "Industri",
    "Wilayah proyek",
    "Kebutuhan bisnis utama",
    "Jenis solusi",
    "Tahap proyek",
    "Tim teknis",
    "Kedalaman teknis",
    "Timeline",
    "Rentang investasi",
    "Jenis engagement",
    "Tujuan bisnis",
    "Detail kontak",
    "Ringkasan cerdas",
  ],
};

const STEP_QUESTIONS = {
  en: [
    "What type of organization are you representing?",
    "Which industry best describes your organization?",
    "Where is this project mainly based?",
    "What do you need help with?",
    "Which solution types best match your initiative?",
    "Where is the project today?",
    "Do you already have a technical team?",
    "Which technical depth areas should we prioritize?",
    "When would you like to move forward?",
    "Do you already have an investment range in mind?",
    "What type of engagement are you considering?",
    "What are you trying to achieve?",
    "Where should we send your project assessment?",
    "Please review your project profile before submission.",
  ],
  es: [
    "¿Qué tipo de organización representás?",
    "¿Qué industria describe mejor a tu organización?",
    "¿Dónde estará basado principalmente este proyecto?",
    "¿Con qué necesitás ayuda?",
    "¿Qué tipos de solución encajan mejor con tu iniciativa?",
    "¿En qué etapa está hoy el proyecto?",
    "¿Ya contás con un equipo técnico?",
    "¿Qué áreas de profundidad técnica debemos priorizar?",
    "¿Cuándo te gustaría avanzar?",
    "¿Ya tenés un rango de inversión en mente?",
    "¿Qué tipo de engagement estás considerando?",
    "¿Qué objetivo querés lograr?",
    "¿A dónde enviamos la evaluación de tu proyecto?",
    "Revisá tu perfil del proyecto antes de enviarlo.",
  ],
  pt: [
    "Que tipo de organização você representa?",
    "Qual indústria descreve melhor a sua organização?",
    "Onde este projeto estará principalmente baseado?",
    "Com o que você precisa de ajuda?",
    "Qual tipo de solução melhor corresponde à sua iniciativa?",
    "Em que fase está o projeto hoje?",
    "Você já tem uma equipe técnica?",
    "Quais áreas de profundidade técnica devemos priorizar?",
    "Quando você gostaria de avançar?",
    "Você já tem uma faixa de investimento em mente?",
    "Que tipo de contratação você está considerando?",
    "O que você está tentando alcançar?",
    "Para onde devemos enviar a avaliação do seu projeto?",
    "Revise o perfil do projeto antes de enviar.",
  ],
  fr: [
    "Quel type d'organisation représentez-vous ?",
    "Quel secteur décrit le mieux votre organisation ?",
    "Où ce projet sera-t-il principalement basé ?",
    "De quoi avez-vous besoin ?",
    "Quel type de solution correspond le mieux à votre initiative ?",
    "Où en est le projet aujourd'hui ?",
    "Avez-vous déjà une équipe technique ?",
    "Quelles zones de profondeur technique devons-nous prioriser ?",
    "Quand souhaitez-vous avancer ?",
    "Avez-vous déjà une fourchette d'investissement en tête ?",
    "Quel type d'engagement envisagez-vous ?",
    "Quel objectif cherchez-vous à atteindre ?",
    "Où devons-nous envoyer l'évaluation de votre projet ?",
    "Veuillez vérifier votre profil projet avant l'envoi.",
  ],
  de: [
    "Welchen Organisationstyp vertreten Sie?",
    "Welche Branche beschreibt Ihre Organisation am besten?",
    "Wo ist dieses Projekt hauptsächlich angesiedelt?",
    "Wobei benötigen Sie Unterstützung?",
    "Welcher Lösungstyp passt am besten zu Ihrer Initiative?",
    "Wo steht das Projekt heute?",
    "Haben Sie bereits ein technisches Team?",
    "Welche Bereiche technischer Tiefe sollen wir priorisieren?",
    "Wann möchten Sie vorankommen?",
    "Haben Sie bereits einen Investitionsrahmen im Kopf?",
    "Welche Form der Zusammenarbeit ziehen Sie in Betracht?",
    "Was möchten Sie erreichen?",
    "Wohin sollen wir Ihre Projektbewertung senden?",
    "Bitte prüfen Sie Ihr Projektprofil vor dem Absenden.",
  ],
  it: [
    "Che tipo di organizzazione rappresenti?",
    "Quale settore descrive meglio la tua organizzazione?",
    "Dove sarà basato principalmente questo progetto?",
    "In cosa hai bisogno di supporto?",
    "Quale tipo di soluzione si adatta meglio alla tua iniziativa?",
    "In che fase è oggi il progetto?",
    "Hai già un team tecnico?",
    "Quali aree di profondità tecnica dovremmo prioritizzare?",
    "Quando vorresti procedere?",
    "Hai già in mente una fascia di investimento?",
    "Che tipo di engagement stai valutando?",
    "Qual è il risultato che vuoi ottenere?",
    "Dove dobbiamo inviare la valutazione del tuo progetto?",
    "Rivedi il profilo del progetto prima dell'invio.",
  ],
  zh: [
    "您代表的是哪种类型的组织？",
    "哪个行业最能描述您的组织？",
    "该项目主要位于哪里？",
    "您希望我们重点协助什么？",
    "哪种解决方案最符合您的项目方向？",
    "项目目前处于哪个阶段？",
    "您是否已有技术团队？",
    "我们应优先关注哪些技术深度方向？",
    "您希望何时推进？",
    "您是否已有投资范围预期？",
    "您考虑哪种合作模式？",
    "您希望实现什么业务目标？",
    "我们应将项目评估发送到哪里？",
    "提交前请先确认您的项目信息。",
  ],
  ja: [
    "どの種類の組織を代表していますか？",
    "あなたの組織を最もよく表す業界はどれですか？",
    "このプロジェクトの主な拠点はどこですか？",
    "どのような支援が必要ですか？",
    "あなたの取り組みに最も合うソリューションはどれですか？",
    "現在、プロジェクトはどの段階ですか？",
    "すでに技術チームはありますか？",
    "どの技術的深度領域を優先すべきですか？",
    "いつ頃前進したいですか？",
    "投資レンジの想定はありますか？",
    "どの契約形態を検討していますか？",
    "どのような目標を達成したいですか？",
    "プロジェクト評価はどこに送ればよいですか？",
    "送信前にプロジェクト情報をご確認ください。",
  ],
  ko: [
    "어떤 유형의 조직을 대표하시나요?",
    "귀사를 가장 잘 설명하는 산업은 무엇인가요?",
    "이 프로젝트는 주로 어느 지역을 기반으로 하나요?",
    "어떤 부분에서 도움이 필요하신가요?",
    "귀하의 이니셔티브에 가장 잘 맞는 솔루션 유형은 무엇인가요?",
    "현재 프로젝트는 어떤 단계인가요?",
    "이미 기술 팀이 있나요?",
    "어떤 기술 심화 영역을 우선순위로 둘까요?",
    "언제 진행하고 싶으신가요?",
    "이미 투자 범위를 생각해 두셨나요?",
    "어떤 계약 형태를 고려하고 계신가요?",
    "달성하려는 비즈니스 목표는 무엇인가요?",
    "프로젝트 평가를 어디로 보내드리면 될까요?",
    "제출 전에 프로젝트 정보를 확인해 주세요.",
  ],
  ar: [
    "ما نوع المؤسسة التي تمثلونها؟",
    "ما القطاع الذي يصف مؤسستكم بشكل أفضل؟",
    "أين يقع هذا المشروع بشكل أساسي؟",
    "في ماذا تحتاجون إلى المساعدة؟",
    "ما نوع الحل الأنسب لمبادرتكم؟",
    "ما هي مرحلة المشروع الحالية؟",
    "هل لديكم فريق تقني بالفعل؟",
    "ما المجالات التقنية ذات الأولوية التي يجب التركيز عليها؟",
    "متى ترغبون في المضي قدمًا؟",
    "هل لديكم نطاق استثماري محدد؟",
    "ما نوع التعاقد الذي تفكرون فيه؟",
    "ما الهدف الذي تحاولون تحقيقه؟",
    "إلى أين نرسل تقييم المشروع؟",
    "يرجى مراجعة ملف المشروع قبل الإرسال.",
  ],
  hi: [
    "आप किस प्रकार के संगठन का प्रतिनिधित्व करते हैं?",
    "आपके संगठन का सबसे अच्छा वर्णन कौन-सा उद्योग करता है?",
    "यह प्रोजेक्ट मुख्य रूप से कहाँ आधारित है?",
    "आपको किस प्रकार की मदद चाहिए?",
    "आपकी पहल के लिए कौन-सा समाधान सबसे उपयुक्त है?",
    "प्रोजेक्ट अभी किस चरण में है?",
    "क्या आपके पास पहले से तकनीकी टीम है?",
    "हमें किन तकनीकी गहराई वाले क्षेत्रों को प्राथमिकता देनी चाहिए?",
    "आप कब आगे बढ़ना चाहते हैं?",
    "क्या आपके पास पहले से निवेश सीमा का विचार है?",
    "आप किस प्रकार की सहभागिता पर विचार कर रहे हैं?",
    "आप क्या हासिल करना चाहते हैं?",
    "हम प्रोजेक्ट मूल्यांकन कहाँ भेजें?",
    "सबमिट करने से पहले कृपया अपनी प्रोजेक्ट प्रोफ़ाइल जांचें।",
  ],
  ru: [
    "Какой тип организации вы представляете?",
    "Какая отрасль лучше всего описывает вашу организацию?",
    "Где в основном будет базироваться этот проект?",
    "В чем вам нужна помощь?",
    "Какой тип решения лучше всего подходит вашей инициативе?",
    "На какой стадии находится проект сейчас?",
    "У вас уже есть техническая команда?",
    "Какие направления технической глубины нам следует приоритизировать?",
    "Когда вы хотите двигаться дальше?",
    "Есть ли у вас ориентир по инвестициям?",
    "Какой формат сотрудничества вы рассматриваете?",
    "Какую цель вы хотите достичь?",
    "Куда отправить оценку вашего проекта?",
    "Пожалуйста, проверьте профиль проекта перед отправкой.",
  ],
  tr: [
    "Hangi tür organizasyonu temsil ediyorsunuz?",
    "Kuruluşunuzu en iyi hangi sektör tanımlar?",
    "Bu proje ağırlıklı olarak nerede konumlanacak?",
    "Hangi konuda desteğe ihtiyacınız var?",
    "Girişiminiz için en uygun çözüm türü hangisi?",
    "Proje bugün hangi aşamada?",
    "Halihazırda bir teknik ekibiniz var mı?",
    "Hangi teknik derinlik alanlarını önceliklendirelim?",
    "Ne zaman ilerlemek istersiniz?",
    "Aklınızda bir yatırım aralığı var mı?",
    "Hangi çalışma modelini değerlendiriyorsunuz?",
    "Hangi sonuca ulaşmak istiyorsunuz?",
    "Proje değerlendirmesini nereye göndermeliyiz?",
    "Göndermeden önce proje profilinizi gözden geçirin.",
  ],
  nl: [
    "Welk type organisatie vertegenwoordigt u?",
    "Welke sector beschrijft uw organisatie het best?",
    "Waar is dit project hoofdzakelijk gevestigd?",
    "Waar heeft u hulp bij nodig?",
    "Welk type oplossing past het best bij uw initiatief?",
    "In welke fase bevindt het project zich nu?",
    "Heeft u al een technisch team?",
    "Welke gebieden van technische diepgang moeten we prioriteren?",
    "Wanneer wilt u vooruitgaan?",
    "Heeft u al een investeringsrange in gedachten?",
    "Welk samenwerkingsmodel overweegt u?",
    "Wat probeert u te bereiken?",
    "Waar moeten we uw projectbeoordeling naartoe sturen?",
    "Controleer uw projectprofiel voordat u verzendt.",
  ],
  pl: [
    "Jaki typ organizacji reprezentujesz?",
    "Która branża najlepiej opisuje Twoją organizację?",
    "Gdzie ten projekt będzie głównie realizowany?",
    "W czym potrzebujesz wsparcia?",
    "Który typ rozwiązania najlepiej pasuje do Twojej inicjatywy?",
    "Na jakim etapie jest dziś projekt?",
    "Czy masz już zespół techniczny?",
    "Które obszary głębokości technicznej powinniśmy priorytetyzować?",
    "Kiedy chcesz przejść dalej?",
    "Czy masz już założony zakres inwestycji?",
    "Jaki typ współpracy rozważasz?",
    "Co chcesz osiągnąć?",
    "Gdzie mamy wysłać ocenę projektu?",
    "Przed wysłaniem sprawdź profil projektu.",
  ],
  id: [
    "Jenis organisasi apa yang Anda wakili?",
    "Industri mana yang paling menggambarkan organisasi Anda?",
    "Di mana proyek ini terutama akan berbasis?",
    "Bantuan apa yang Anda butuhkan?",
    "Jenis solusi apa yang paling cocok dengan inisiatif Anda?",
    "Di tahap mana proyek ini saat ini?",
    "Apakah Anda sudah memiliki tim teknis?",
    "Area kedalaman teknis mana yang harus kami prioritaskan?",
    "Kapan Anda ingin melangkah maju?",
    "Apakah Anda sudah memiliki kisaran investasi?",
    "Jenis engagement apa yang Anda pertimbangkan?",
    "Apa yang ingin Anda capai?",
    "Ke mana kami harus mengirimkan evaluasi proyek Anda?",
    "Silakan tinjau profil proyek Anda sebelum mengirim.",
  ],
};

const getLanguageValue = (map, language, index) => {
  if (map[language]?.[index]) {
    return map[language][index];
  }
  return map[fallbackLanguage]?.[index] || "";
};

const stepCopy = Object.fromEntries(
  STEP_KEYS.map((key, index) => [
    key,
    {
      title: Object.fromEntries(
        SUPPORTED_DISCOVERY_LANGUAGES.map((language) => [
          language,
          getLanguageValue(STEP_TITLES, language, index),
        ]),
      ),
      question: Object.fromEntries(
        SUPPORTED_DISCOVERY_LANGUAGES.map((language) => [
          language,
          getLanguageValue(STEP_QUESTIONS, language, index),
        ]),
      ),
    },
  ]),
);

const optionLabels = {
  "Startup": {
    "es": "Puesta en marcha",
    "pt": "Comece",
    "fr": "Démarrer",
    "de": "Start-up",
    "it": "Avvio",
    "zh": "启动",
    "ja": "起動する",
    "ko": "시작",
    "ar": "بدء",
    "hi": "चालू होना",
    "ru": "Запускать",
    "tr": "Başlatmak",
    "nl": "Opstarten",
    "pl": "Uruchomienie",
    "id": "Rintisan"
  },
  "Small business": {
    "es": "Pequeña empresa",
    "pt": "Pequena empresa",
    "fr": "Petite entreprise",
    "de": "Kleinunternehmen",
    "it": "Piccola impresa",
    "zh": "小型企业",
    "ja": "中小企業",
    "ko": "중소기업",
    "ar": "الأعمال الصغيرة",
    "hi": "छोटा व्यवसाय",
    "ru": "Малый бизнес",
    "tr": "Küçük işletme",
    "nl": "Klein bedrijf",
    "pl": "Mały biznes",
    "id": "Bisnis kecil"
  },
  "Medium-sized company": {
    "es": "mediana empresa",
    "pt": "Empresa de médio porte",
    "fr": "Entreprise de taille moyenne",
    "de": "Mittelständisches Unternehmen",
    "it": "Azienda di medie dimensioni",
    "zh": "中型企业",
    "ja": "中堅企業",
    "ko": "중견기업",
    "ar": "شركة متوسطة الحجم",
    "hi": "मध्यम आकार की कंपनी",
    "ru": "Компания среднего размера",
    "tr": "Orta ölçekli şirket",
    "nl": "Middelgroot bedrijf",
    "pl": "Firma średniej wielkości",
    "id": "Perusahaan menengah"
  },
  "Large company": {
    "es": "Gran empresa",
    "pt": "Grande empresa",
    "fr": "Grande entreprise",
    "de": "Großes Unternehmen",
    "it": "Grande azienda",
    "zh": "大公司",
    "ja": "大企業",
    "ko": "대기업",
    "ar": "شركة كبيرة",
    "hi": "बड़ी कंपनी",
    "ru": "Крупная компания",
    "tr": "Büyük şirket",
    "nl": "Groot bedrijf",
    "pl": "Duża firma",
    "id": "Perusahaan besar"
  },
  "Enterprise": {
    "es": "Empresa",
    "pt": "Empresa",
    "fr": "Entreprise",
    "de": "Unternehmen",
    "it": "Impresa",
    "zh": "企业",
    "ja": "企業",
    "ko": "기업",
    "ar": "مَشرُوع",
    "hi": "उद्यम",
    "ru": "Предприятие",
    "tr": "Girişim",
    "nl": "Onderneming",
    "pl": "Przedsiębiorstwo",
    "id": "Perusahaan"
  },
  "Agency / consulting firm": {
    "es": "Agencia/empresa consultora",
    "pt": "Agência/empresa de consultoria",
    "fr": "Agence / Cabinet de conseil",
    "de": "Agentur / Beratungsunternehmen",
    "it": "Agenzia/società di consulenza",
    "zh": "代理/咨询公司",
    "ja": "代理店・コンサルティング会社",
    "ko": "에이전시/컨설팅회사",
    "ar": "وكالة / شركة استشارية",
    "hi": "एजेंसी/परामर्शदाता फर्म",
    "ru": "Агентство/консалтинговая фирма",
    "tr": "Ajans / danışmanlık firması",
    "nl": "Agentschap/adviesbureau",
    "pl": "Agencja/firma konsultingowa",
    "id": "Agensi/perusahaan konsultan"
  },
  "Government / Public sector": {
    "es": "Gobierno / Sector público",
    "pt": "Governo / Setor público",
    "fr": "Gouvernement / Secteur public",
    "de": "Regierung/öffentlicher Sektor",
    "it": "Governo/Settore pubblico",
    "zh": "政府/公共部门",
    "ja": "政府/公共部門",
    "ko": "정부/공공부문",
    "ar": "الحكومة / القطاع العام",
    "hi": "सरकारी/सार्वजनिक क्षेत्र",
    "ru": "Правительство / Государственный сектор",
    "tr": "Hükümet / Kamu sektörü",
    "nl": "Overheid / Publieke sector",
    "pl": "Rząd / Sektor publiczny",
    "id": "Pemerintah/Sektor Publik"
  },
  "Educational institution": {
    "es": "Institución educativa",
    "pt": "Instituição educacional",
    "fr": "Établissement d'enseignement",
    "de": "Bildungseinrichtung",
    "it": "Istituzione educativa",
    "zh": "教育机构",
    "ja": "教育機関",
    "ko": "교육기관",
    "ar": "مؤسسة تعليمية",
    "hi": "शैक्षिक संस्था",
    "ru": "Учебное заведение",
    "tr": "Eğitim kurumu",
    "nl": "Onderwijsinstelling",
    "pl": "Instytucja edukacyjna",
    "id": "Institusi pendidikan"
  },
  "Non-profit organization": {
    "es": "organización sin fines de lucro",
    "pt": "Organização sem fins lucrativos",
    "fr": "Organisation à but non lucratif",
    "de": "Gemeinnützige Organisation",
    "it": "Organizzazione senza scopo di lucro",
    "zh": "非营利组织",
    "ja": "非営利団体",
    "ko": "비영리단체",
    "ar": "منظمة غير ربحية",
    "hi": "गैर-लाभकारी संगठन",
    "ru": "Некоммерческая организация",
    "tr": "Kâr amacı gütmeyen kuruluş",
    "nl": "Non-profit organisatie",
    "pl": "Organizacja non-profit",
    "id": "Organisasi nirlaba"
  },
  "Banking": {
    "es": "Bancario",
    "pt": "Bancário",
    "fr": "Bancaire",
    "de": "Bankwesen",
    "it": "Bancario",
    "zh": "银行业",
    "ja": "銀行業",
    "ko": "은행업",
    "ar": "الخدمات المصرفية",
    "hi": "बैंकिंग",
    "ru": "Банковское дело",
    "tr": "Bankacılık",
    "nl": "Bankieren",
    "pl": "Bankowy",
    "id": "Perbankan"
  },
  "Fintech": {
    "es": "tecnología financiera",
    "pt": "Fintech",
    "fr": "Technologie financière",
    "de": "Fintech",
    "it": "Fintech",
    "zh": "金融科技",
    "ja": "フィンテック",
    "ko": "핀테크",
    "ar": "التكنولوجيا المالية",
    "hi": "फिनटेक",
    "ru": "Финтех",
    "tr": "Fintech",
    "nl": "Fintech",
    "pl": "Fintech",
    "id": "Fintech"
  },
  "Insurance": {
    "es": "Seguro",
    "pt": "Seguro",
    "fr": "Assurance",
    "de": "Versicherung",
    "it": "Assicurazione",
    "zh": "保险",
    "ja": "保険",
    "ko": "보험",
    "ar": "تأمين",
    "hi": "बीमा",
    "ru": "Страхование",
    "tr": "Sigorta",
    "nl": "Verzekering",
    "pl": "Ubezpieczenie",
    "id": "Asuransi"
  },
  "Payments": {
    "es": "Pagos",
    "pt": "Pagamentos",
    "fr": "Paiements",
    "de": "Zahlungen",
    "it": "Pagamenti",
    "zh": "付款方式",
    "ja": "支払い",
    "ko": "결제",
    "ar": "المدفوعات",
    "hi": "भुगतान",
    "ru": "Платежи",
    "tr": "Ödemeler",
    "nl": "Betalingen",
    "pl": "Płatności",
    "id": "Pembayaran"
  },
  "Real estate": {
    "es": "Bienes raíces",
    "pt": "Imobiliária",
    "fr": "Immobilier",
    "de": "Immobilie",
    "it": "Immobiliare",
    "zh": "房地产",
    "ja": "不動産",
    "ko": "부동산",
    "ar": "العقارات",
    "hi": "रियल एस्टेट",
    "ru": "Недвижимость",
    "tr": "Gayrimenkul",
    "nl": "Vastgoed",
    "pl": "Nieruchomość",
    "id": "Real estat"
  },
  "Retail": {
    "es": "Minorista",
    "pt": "Varejo",
    "fr": "Vente au détail",
    "de": "Einzelhandel",
    "it": "Vedere al dettaglio",
    "zh": "零售",
    "ja": "小売り",
    "ko": "소매",
    "ar": "بيع بالتجزئة",
    "hi": "खुदरा",
    "ru": "Розничная торговля",
    "tr": "Perakende",
    "nl": "Detailhandel",
    "pl": "Sprzedaż detaliczna",
    "id": "Pengecer"
  },
  "E-commerce": {
    "es": "Comercio electrónico",
    "pt": "Comércio eletrônico",
    "fr": "Commerce électronique",
    "de": "E-Commerce",
    "it": "Commercio elettronico",
    "zh": "电子商务",
    "ja": "電子商取引",
    "ko": "전자상거래",
    "ar": "التجارة الإلكترونية",
    "hi": "ई-कॉमर्स",
    "ru": "Электронная коммерция",
    "tr": "E-ticaret",
    "nl": "E-commerce",
    "pl": "Handel elektroniczny",
    "id": "perdagangan elektronik"
  },
  "Hospitality": {
    "es": "Hospitalidad",
    "pt": "Hospitalidade",
    "fr": "Hospitalité",
    "de": "Gastfreundschaft",
    "it": "Ospitalità",
    "zh": "款待",
    "ja": "ホスピタリティ",
    "ko": "환대",
    "ar": "ضيافة",
    "hi": "मेहमाननवाज़ी",
    "ru": "Гостеприимство",
    "tr": "Misafirperverlik",
    "nl": "Gastvrijheid",
    "pl": "Gościnność",
    "id": "Keramahan"
  },
  "Travel / Tourism": {
    "es": "Viajes / Turismo",
    "pt": "Viagens / Turismo",
    "fr": "Voyage / Tourisme",
    "de": "Reisen / Tourismus",
    "it": "Viaggi/Turismo",
    "zh": "旅游/旅游",
    "ja": "旅行・観光",
    "ko": "여행/관광",
    "ar": "السفر / السياحة",
    "hi": "यात्रा पर्यटन",
    "ru": "Путешествия / Туризм",
    "tr": "Seyahat / Turizm",
    "nl": "Reizen / Toerisme",
    "pl": "Podróże / Turystyka",
    "id": "Perjalanan / Pariwisata"
  },
  "Logistics / Delivery": {
    "es": "Logística / Entrega",
    "pt": "Logística / Entrega",
    "fr": "Logistique / Livraison",
    "de": "Logistik / Lieferung",
    "it": "Logistica/Consegna",
    "zh": "物流/配送",
    "ja": "物流・配送",
    "ko": "물류/배송",
    "ar": "الخدمات اللوجستية / التسليم",
    "hi": "रसद/वितरण",
    "ru": "Логистика / Доставка",
    "tr": "Lojistik / Teslimat",
    "nl": "Logistiek / Levering",
    "pl": "Logistyka / Dostawa",
    "id": "Logistik / Pengiriman"
  },
  "Professional services": {
    "es": "Servicios profesionales",
    "pt": "Serviços profissionais",
    "fr": "Services professionnels",
    "de": "Professionelle Dienstleistungen",
    "it": "Servizi professionali",
    "zh": "专业服务",
    "ja": "プロフェッショナルサービス",
    "ko": "전문 서비스",
    "ar": "الخدمات المهنية",
    "hi": "पेशेवर सेवाएं",
    "ru": "Профессиональные услуги",
    "tr": "Profesyonel hizmetler",
    "nl": "Professionele diensten",
    "pl": "Profesjonalne usługi",
    "id": "Layanan profesional"
  },
  "Healthcare": {
    "es": "Cuidado de la salud",
    "pt": "Assistência médica",
    "fr": "Soins de santé",
    "de": "Gesundheitspflege",
    "it": "Assistenza sanitaria",
    "zh": "卫生保健",
    "ja": "健康管理",
    "ko": "헬스케어",
    "ar": "الرعاية الصحية",
    "hi": "स्वास्थ्य देखभाल",
    "ru": "Здравоохранение",
    "tr": "Sağlık hizmeti",
    "nl": "Gezondheidszorg",
    "pl": "Opieka zdrowotna",
    "id": "Kesehatan"
  },
  "Wellness / Fitness": {
    "es": "Bienestar / Fitness",
    "pt": "Bem-estar / Fitness",
    "fr": "Bien-être / Remise en forme",
    "de": "Wellness / Fitness",
    "it": "Benessere/Fitness",
    "zh": "健康/健身",
    "ja": "ウェルネス / フィットネス",
    "ko": "웰니스/피트니스",
    "ar": "العافية / اللياقة البدنية",
    "hi": "तंदुरूस्ती/तंदुरुस्ती",
    "ru": "Оздоровление / Фитнес",
    "tr": "Sağlık / Fitness",
    "nl": "Welzijn / Fitness",
    "pl": "Wellness/Fitness",
    "id": "Kesehatan / Kebugaran"
  },
  "Education": {
    "es": "Educación",
    "pt": "Educação",
    "fr": "Éducation",
    "de": "Ausbildung",
    "it": "Istruzione",
    "zh": "教育",
    "ja": "教育",
    "ko": "교육",
    "ar": "تعليم",
    "hi": "शिक्षा",
    "ru": "Образование",
    "tr": "Eğitim",
    "nl": "Onderwijs",
    "pl": "Edukacja",
    "id": "Pendidikan"
  },
  "E-learning": {
    "es": "aprendizaje electrónico",
    "pt": "E-learning",
    "fr": "Apprentissage en ligne",
    "de": "E-Learning",
    "it": "E-learning",
    "zh": "电子学习",
    "ja": "Eラーニング",
    "ko": "이러닝",
    "ar": "التعلم الإلكتروني",
    "hi": "ई सीखना",
    "ru": "Электронное обучение",
    "tr": "E-öğrenme",
    "nl": "E-leren",
    "pl": "E-learning",
    "id": "E-pembelajaran"
  },
  "Public services": {
    "es": "Servicios publicos",
    "pt": "Serviços públicos",
    "fr": "Services publics",
    "de": "Öffentliche Dienstleistungen",
    "it": "Servizi pubblici",
    "zh": "公共服务",
    "ja": "公共サービス",
    "ko": "공공 서비스",
    "ar": "الخدمات العامة",
    "hi": "सार्वजनिक सेवाएं",
    "ru": "Государственные услуги",
    "tr": "Kamu hizmetleri",
    "nl": "Openbare diensten",
    "pl": "Usługi publiczne",
    "id": "Pelayanan publik"
  },
  "Non-profit / NGO": {
    "es": "Sin fines de lucro / ONG",
    "pt": "Sem fins lucrativos / ONG",
    "fr": "Association à but non lucratif/ONG",
    "de": "Gemeinnützig / NGO",
    "it": "Senza scopo di lucro/ONG",
    "zh": "非营利/非政府组织",
    "ja": "非営利/NGO",
    "ko": "비영리/NGO",
    "ar": "غير ربحية / منظمة غير حكومية",
    "hi": "गैर-लाभकारी/एनजीओ",
    "ru": "Некоммерческая / НПО",
    "tr": "Kâr amacı gütmeyen / STK",
    "nl": "Non-profit/NGO",
    "pl": "Organizacja non-profit / organizacja pozarządowa",
    "id": "Nirlaba / LSM"
  },
  "Software / SaaS": {
    "es": "Software/SaaS",
    "pt": "Software/SaaS",
    "fr": "Logiciel / SaaS",
    "de": "Software / SaaS",
    "it": "Software/SaaS",
    "zh": "软件/SaaS",
    "ja": "ソフトウェア / SaaS",
    "ko": "소프트웨어/SaaS",
    "ar": "البرمجيات / ادارة العلاقات مع",
    "hi": "सॉफ्टवेयर/सास",
    "ru": "Программное обеспечение / SaaS",
    "tr": "Yazılım / SaaS",
    "nl": "Software/SaaS",
    "pl": "Oprogramowanie/SaaS",
    "id": "Perangkat Lunak / SaaS"
  },
  "AI / Automation": {
    "es": "IA / Automatización",
    "pt": "IA / Automação",
    "fr": "IA / Automatisation",
    "de": "KI / Automatisierung",
    "it": "IA/Automazione",
    "zh": "人工智能/自动化",
    "ja": "AI・自動化",
    "ko": "AI / 자동화",
    "ar": "الذكاء الاصطناعي / الأتمتة",
    "hi": "एआई/स्वचालन",
    "ru": "ИИ/Автоматизация",
    "tr": "Yapay Zeka / Otomasyon",
    "nl": "AI / Automatisering",
    "pl": "Sztuczna inteligencja / automatyzacja",
    "id": "AI / Otomatisasi"
  },
  "Telecommunications": {
    "es": "Telecomunicaciones",
    "pt": "Telecomunicações",
    "fr": "Télécommunications",
    "de": "Telekommunikation",
    "it": "Telecomunicazioni",
    "zh": "电信",
    "ja": "電気通信",
    "ko": "통신",
    "ar": "الاتصالات",
    "hi": "दूरसंचार",
    "ru": "Телекоммуникации",
    "tr": "Telekomünikasyon",
    "nl": "Telecommunicatie",
    "pl": "Telekomunikacja",
    "id": "Telekomunikasi"
  },
  "Media": {
    "es": "Medios de comunicación",
    "pt": "Mídia",
    "fr": "Médias",
    "de": "Medien",
    "it": "Media",
    "zh": "媒体",
    "ja": "メディア",
    "ko": "메디아",
    "ar": "وسائط",
    "hi": "मिडिया",
    "ru": "СМИ",
    "tr": "Medya",
    "nl": "Media",
    "pl": "Głoska bezdźwięczna",
    "id": "Media"
  },
  "Entertainment": {
    "es": "Entretenimiento",
    "pt": "Entretenimento",
    "fr": "Divertissement",
    "de": "Unterhaltung",
    "it": "Divertimento",
    "zh": "娱乐",
    "ja": "エンターテインメント",
    "ko": "오락",
    "ar": "ترفيه",
    "hi": "मनोरंजन",
    "ru": "Развлечение",
    "tr": "Eğlence",
    "nl": "Amusement",
    "pl": "Rozrywka",
    "id": "Hiburan"
  },
  "Marketing / Advertising": {
    "es": "Márketing/Publicidad",
    "pt": "Marketing / Publicidade",
    "fr": "Marketing/Publicité",
    "de": "Marketing / Werbung",
    "it": "Marketing/Pubblicità",
    "zh": "营销/广告",
    "ja": "マーケティング/広告",
    "ko": "마케팅/광고",
    "ar": "التسويق / الإعلان",
    "hi": "विपणन विज्ञापन",
    "ru": "Маркетинг / Реклама",
    "tr": "Pazarlama / Reklamcılık",
    "nl": "Marketing/reclame",
    "pl": "Marketing/reklama",
    "id": "Pemasaran / Periklanan"
  },
  "Gaming": {
    "es": "Juego de azar",
    "pt": "Jogos",
    "fr": "Jeux",
    "de": "Spielen",
    "it": "Gioco",
    "zh": "赌博",
    "ja": "ゲーム",
    "ko": "노름",
    "ar": "الألعاب",
    "hi": "जुआ",
    "ru": "Игры",
    "tr": "Oyun",
    "nl": "Gamen",
    "pl": "Hazard",
    "id": "Permainan"
  },
  "Manufacturing": {
    "es": "Fabricación",
    "pt": "Fabricação",
    "fr": "Fabrication",
    "de": "Herstellung",
    "it": "Produzione",
    "zh": "制造业",
    "ja": "製造業",
    "ko": "조작",
    "ar": "تصنيع",
    "hi": "उत्पादन",
    "ru": "Производство",
    "tr": "Üretme",
    "nl": "Productie",
    "pl": "Produkcja",
    "id": "Manufaktur"
  },
  "Energy": {
    "es": "Energía",
    "pt": "Energia",
    "fr": "Énergie",
    "de": "Energie",
    "it": "Energia",
    "zh": "活力",
    "ja": "エネルギー",
    "ko": "에너지",
    "ar": "طاقة",
    "hi": "ऊर्जा",
    "ru": "Энергия",
    "tr": "Enerji",
    "nl": "Energie",
    "pl": "Energia",
    "id": "Energi"
  },
  "Agriculture / Agritech": {
    "es": "Agricultura / Agrotecnología",
    "pt": "Agricultura / Agritech",
    "fr": "Agriculture/Agrotechnologie",
    "de": "Landwirtschaft / Agritech",
    "it": "Agricoltura/Agritech",
    "zh": "农业/农业科技",
    "ja": "農業・アグリテック",
    "ko": "농업 / 농업 기술",
    "ar": "الزراعة / التكنولوجيا الزراعية",
    "hi": "कृषि/एग्रीटेक",
    "ru": "Сельское хозяйство / Агротехнологии",
    "tr": "Tarım / Tarım Teknolojisi",
    "nl": "Landbouw / Agritech",
    "pl": "Rolnictwo / Agritech",
    "id": "Pertanian / Agritech"
  },
  "Construction": {
    "es": "Construcción",
    "pt": "Construção",
    "fr": "Construction",
    "de": "Konstruktion",
    "it": "Costruzione",
    "zh": "建造",
    "ja": "工事",
    "ko": "건설",
    "ar": "بناء",
    "hi": "निर्माण",
    "ru": "Строительство",
    "tr": "Yapı",
    "nl": "Bouw",
    "pl": "Budowa",
    "id": "Konstruksi"
  },
  "Transportation": {
    "es": "Transporte",
    "pt": "Transporte",
    "fr": "Transport",
    "de": "Transport",
    "it": "Trasporti",
    "zh": "运输",
    "ja": "交通機関",
    "ko": "운송",
    "ar": "مواصلات",
    "hi": "परिवहन",
    "ru": "Транспорт",
    "tr": "Toplu taşıma",
    "nl": "Vervoer",
    "pl": "Transport",
    "id": "Angkutan"
  },
  "Supply chain": {
    "es": "cadena de suministro",
    "pt": "Cadeia de mantimentos",
    "fr": "Chaîne d'approvisionnement",
    "de": "Lieferkette",
    "it": "Catena di fornitura",
    "zh": "供应链",
    "ja": "サプライチェーン",
    "ko": "공급망",
    "ar": "الموردين",
    "hi": "आपूर्ति श्रृंखला",
    "ru": "Цепочка поставок",
    "tr": "Tedarik zinciri",
    "nl": "Toeleveringsketen",
    "pl": "Łańcuch dostaw",
    "id": "Rantai pasokan"
  },
  "Enterprise operations": {
    "es": "Operaciones empresariales",
    "pt": "Operações empresariais",
    "fr": "Opérations d'entreprise",
    "de": "Unternehmensbetrieb",
    "it": "Operazioni aziendali",
    "zh": "企业运营",
    "ja": "エンタープライズ業務",
    "ko": "기업 운영",
    "ar": "عمليات المؤسسة",
    "hi": "उद्यम संचालन",
    "ru": "Операции предприятия",
    "tr": "Kurumsal operasyonlar",
    "nl": "Bedrijfsactiviteiten",
    "pl": "Operacje przedsiębiorstwa",
    "id": "Operasi perusahaan"
  },
  "Other industry": {
    "es": "Otra industria",
    "pt": "Outra indústria",
    "fr": "Autre industrie",
    "de": "Andere Industrie",
    "it": "Altro settore",
    "zh": "其他行业",
    "ja": "他産業",
    "ko": "기타 산업",
    "ar": "صناعة أخرى",
    "hi": "अन्य उद्योग",
    "ru": "Другая отрасль",
    "tr": "Diğer endüstri",
    "nl": "Andere industrie",
    "pl": "Inna branża",
    "id": "Industri lainnya"
  },
  "Not sure / mixed industry": {
    "es": "No estoy seguro/industria mixta",
    "pt": "Não tenho certeza/indústria mista",
    "fr": "Je ne suis pas sûr / industrie mixte",
    "de": "Nicht sicher / gemischte Branche",
    "it": "Non sono sicuro/settore misto",
    "zh": "不确定/混合行业",
    "ja": "わからない / 混合業種",
    "ko": "확실하지 않음/혼합 업종",
    "ar": "لست متأكدا / صناعة مختلطة",
    "hi": "निश्चित नहीं/मिश्रित उद्योग",
    "ru": "Не уверен/смешанная отрасль",
    "tr": "Emin değilim / karışık endüstri",
    "nl": "Niet zeker / gemengde industrie",
    "pl": "Nie jestem pewien/branża mieszana",
    "id": "Tidak yakin / industri campuran"
  },
  "Build a new digital product": {
    "es": "Construir un nuevo producto digital",
    "pt": "Construa um novo produto digital",
    "fr": "Créer un nouveau produit numérique",
    "de": "Erstellen Sie ein neues digitales Produkt",
    "it": "Costruisci un nuovo prodotto digitale",
    "zh": "构建新的数字产品",
    "ja": "新しいデジタル製品を構築する",
    "ko": "새로운 디지털 제품 구축",
    "ar": "بناء منتج رقمي جديد",
    "hi": "एक नया डिजिटल उत्पाद बनाएं",
    "ru": "Создайте новый цифровой продукт",
    "tr": "Yeni bir dijital ürün oluşturun",
    "nl": "Bouw een nieuw digitaal product",
    "pl": "Stwórz nowy produkt cyfrowy",
    "id": "Bangun produk digital baru"
  },
  "Modernize an existing system": {
    "es": "Modernizar un sistema existente",
    "pt": "Modernize um sistema existente",
    "fr": "Moderniser un système existant",
    "de": "Modernisieren Sie ein bestehendes System",
    "it": "Modernizzare un sistema esistente",
    "zh": "对现有系统进行现代化改造",
    "ja": "既存のシステムを最新化する",
    "ko": "기존 시스템 현대화",
    "ar": "تحديث النظام الحالي",
    "hi": "किसी मौजूदा प्रणाली का आधुनिकीकरण करें",
    "ru": "Модернизировать существующую систему",
    "tr": "Mevcut bir sistemi modernleştirin",
    "nl": "Moderniseer een bestaand systeem",
    "pl": "Zmodernizuj istniejący system",
    "id": "Memodernisasi sistem yang sudah ada"
  },
  "Build a mobile app": {
    "es": "Crear una aplicación móvil",
    "pt": "Crie um aplicativo móvel",
    "fr": "Créer une application mobile",
    "de": "Erstellen Sie eine mobile App",
    "it": "Crea un'app mobile",
    "zh": "构建移动应用程序",
    "ja": "モバイルアプリを構築する",
    "ko": "모바일 앱 구축",
    "ar": "إنشاء تطبيق جوال",
    "hi": "एक मोबाइल ऐप बनाएं",
    "ru": "Создайте мобильное приложение",
    "tr": "Mobil uygulama oluşturun",
    "nl": "Bouw een mobiele app",
    "pl": "Zbuduj aplikację mobilną",
    "id": "Bangun aplikasi seluler"
  },
  "Build a web platform": {
    "es": "Construir una plataforma web",
    "pt": "Construa uma plataforma web",
    "fr": "Construire une plateforme web",
    "de": "Erstellen Sie eine Webplattform",
    "it": "Costruisci una piattaforma web",
    "zh": "建立网络平台",
    "ja": "ウェブプラットフォームを構築する",
    "ko": "웹 플랫폼 구축",
    "ar": "بناء منصة على شبكة الإنترنت",
    "hi": "एक वेब प्लेटफ़ॉर्म बनाएं",
    "ru": "Создайте веб-платформу",
    "tr": "Bir web platformu oluşturun",
    "nl": "Bouw een webplatform",
    "pl": "Zbuduj platformę internetową",
    "id": "Bangun platform web"
  },
  "Build backend services or APIs": {
    "es": "Cree servicios backend o API",
    "pt": "Crie serviços de back-end ou APIs",
    "fr": "Créer des services backend ou des API",
    "de": "Erstellen Sie Backend-Dienste oder APIs",
    "it": "Costruisci servizi di backend o API",
    "zh": "构建后端服务或 API",
    "ja": "バックエンドサービスまたはAPIを構築する",
    "ko": "백엔드 서비스 또는 API 구축",
    "ar": "بناء خدمات الواجهة الخلفية أو واجهات برمجة التطبيقات",
    "hi": "बैकएंड सेवाएँ या API बनाएँ",
    "ru": "Создавайте серверные службы или API",
    "tr": "Arka uç hizmetleri veya API'ler oluşturun",
    "nl": "Bouw backend-services of API's",
    "pl": "Twórz usługi backendu lub interfejsy API",
    "id": "Bangun layanan backend atau API"
  },
  "Integrate existing systems": {
    "es": "Integrar sistemas existentes",
    "pt": "Integre sistemas existentes",
    "fr": "Intégrer les systèmes existants",
    "de": "Bestehende Systeme integrieren",
    "it": "Integrare i sistemi esistenti",
    "zh": "整合现有系统",
    "ja": "既存のシステムを統合する",
    "ko": "기존 시스템 통합",
    "ar": "دمج الأنظمة الحالية",
    "hi": "मौजूदा सिस्टम को एकीकृत करें",
    "ru": "Интегрируйте существующие системы",
    "tr": "Mevcut sistemleri entegre edin",
    "nl": "Integreer bestaande systemen",
    "pl": "Zintegruj istniejące systemy",
    "id": "Integrasikan sistem yang ada"
  },
  "Add AI / LLM capabilities to an existing product": {
    "es": "Agregar capacidades de IA/LLM a un producto existente",
    "pt": "Adicione recursos de AI/LLM a um produto existente",
    "fr": "Ajouter des fonctionnalités IA/LLM à un produit existant",
    "de": "Fügen Sie einem vorhandenen Produkt KI-/LLM-Funktionen hinzu",
    "it": "Aggiungi funzionalità AI/LLM a un prodotto esistente",
    "zh": "为现有产品添加 AI/LLM 功能",
    "ja": "既存の製品に AI / LLM 機能を追加する",
    "ko": "기존 제품에 AI/LLM 기능 추가",
    "ar": "أضف قدرات AI / LLM إلى منتج موجود",
    "hi": "किसी मौजूदा उत्पाद में AI/LLM क्षमताएं जोड़ें",
    "ru": "Добавьте возможности AI/LLM в существующий продукт",
    "tr": "Mevcut bir ürüne AI / LLM yetenekleri ekleyin",
    "nl": "Voeg AI/LLM-mogelijkheden toe aan een bestaand product",
    "pl": "Dodaj możliwości AI/LLM do istniejącego produktu",
    "id": "Tambahkan kemampuan AI/LLM ke produk yang sudah ada"
  },
  "Define a technical strategy before development": {
    "es": "Definir una estrategia técnica antes del desarrollo.",
    "pt": "Defina uma estratégia técnica antes do desenvolvimento",
    "fr": "Définir une stratégie technique avant le développement",
    "de": "Definieren Sie vor der Entwicklung eine technische Strategie",
    "it": "Definire una strategia tecnica prima dello sviluppo",
    "zh": "开发前定义技术策略",
    "ja": "開発前に技術戦略を定義する",
    "ko": "개발 전 기술 전략 정의",
    "ar": "تحديد استراتيجية فنية قبل التطوير",
    "hi": "विकास से पहले एक तकनीकी रणनीति परिभाषित करें",
    "ru": "Определите техническую стратегию перед разработкой",
    "tr": "Geliştirmeden önce teknik bir strateji tanımlayın",
    "nl": "Definieer een technische strategie vóór de ontwikkeling",
    "pl": "Zdefiniuj strategię techniczną przed rozwojem",
    "id": "Tentukan strategi teknis sebelum pengembangan"
  },
  "Not sure yet": {
    "es": "No estoy seguro todavía",
    "pt": "Ainda não tenho certeza",
    "fr": "Je ne suis pas encore sûr",
    "de": "Noch nicht sicher",
    "it": "Non sono ancora sicuro",
    "zh": "还不确定",
    "ja": "まだわかりません",
    "ko": "아직 확실하지 않음",
    "ar": "لست متأكدا بعد",
    "hi": "अभी तक निश्चित नहीं हूं",
    "ru": "Пока не уверен",
    "tr": "Henüz emin değilim",
    "nl": "Nog niet zeker",
    "pl": "Jeszcze nie jestem pewien",
    "id": "Belum yakin"
  },
  "Mobile application": {
    "es": "Aplicación móvil",
    "pt": "Aplicativo móvel",
    "fr": "Application mobile",
    "de": "Mobile Anwendung",
    "it": "Applicazione mobile",
    "zh": "移动应用",
    "ja": "モバイルアプリケーション",
    "ko": "모바일 애플리케이션",
    "ar": "تطبيق الهاتف المحمول",
    "hi": "मोबाइल एप्लीकेशन",
    "ru": "Мобильное приложение",
    "tr": "Mobil uygulama",
    "nl": "Mobiele applicatie",
    "pl": "Aplikacja mobilna",
    "id": "Aplikasi seluler"
  },
  "Web application / SaaS platform": {
    "es": "Aplicación web/plataforma SaaS",
    "pt": "Aplicativo web/plataforma SaaS",
    "fr": "Application Web / Plateforme SaaS",
    "de": "Webanwendung / SaaS-Plattform",
    "it": "Applicazione Web/piattaforma SaaS",
    "zh": "Web应用程序/SaaS平台",
    "ja": "Webアプリケーション/SaaSプラットフォーム",
    "ko": "웹 애플리케이션 / SaaS 플랫폼",
    "ar": "تطبيق ويب / منصة SaaS",
    "hi": "वेब एप्लिकेशन/सास प्लेटफॉर्म",
    "ru": "Веб-приложение/SaaS-платформа",
    "tr": "Web uygulaması / SaaS platformu",
    "nl": "Webapplicatie / SaaS-platform",
    "pl": "Aplikacja internetowa/platforma SaaS",
    "id": "Aplikasi web/platform SaaS"
  },
  "Backend / API platform": {
    "es": "Plataforma back-end/API",
    "pt": "Plataforma de back-end/API",
    "fr": "Plateforme back-end/API",
    "de": "Backend-/API-Plattform",
    "it": "Piattaforma backend/API",
    "zh": "后端/API平台",
    "ja": "バックエンド/APIプラットフォーム",
    "ko": "백엔드/API 플랫폼",
    "ar": "منصة الواجهة الخلفية/واجهة برمجة التطبيقات (API).",
    "hi": "बैकएंड/एपीआई प्लेटफॉर्म",
    "ru": "Бэкэнд/API-платформа",
    "tr": "Arka uç / API platformu",
    "nl": "Backend/API-platform",
    "pl": "Platforma backendowa/API",
    "id": "Platform ujung belakang/API"
  },
  "Customer portal": {
    "es": "Portal del cliente",
    "pt": "Portal do cliente",
    "fr": "Portail client",
    "de": "Kundenportal",
    "it": "Portale clienti",
    "zh": "客户门户",
    "ja": "カスタマーポータル",
    "ko": "고객포털",
    "ar": "بوابة العملاء",
    "hi": "ग्राहक पोर्टल",
    "ru": "Клиентский портал",
    "tr": "Müşteri portalı",
    "nl": "Klantenportaal",
    "pl": "Portalu klienta",
    "id": "Portal pelanggan"
  },
  "Admin dashboard": {
    "es": "Panel de administración",
    "pt": "Painel de administração",
    "fr": "Tableau de bord d'administration",
    "de": "Admin-Dashboard",
    "it": "Pannello di amministrazione",
    "zh": "管理仪表板",
    "ja": "管理者ダッシュボード",
    "ko": "관리 대시보드",
    "ar": "لوحة تحكم المشرف",
    "hi": "व्यवस्थापक डैशबोर्ड",
    "ru": "Панель администратора",
    "tr": "Yönetici kontrol paneli",
    "nl": "Beheerdashboard",
    "pl": "Pulpit administratora",
    "id": "Dasbor Admin"
  },
  "AI assistant / chatbot": {
    "es": "Asistente de IA/chatbot",
    "pt": "Assistente de IA / chatbot",
    "fr": "Assistant IA / chatbot",
    "de": "KI-Assistent / Chatbot",
    "it": "Assistente AI/chatbot",
    "zh": "AI助手/聊天机器人",
    "ja": "AIアシスタント/チャットボット",
    "ko": "AI 비서/챗봇",
    "ar": "مساعد الذكاء الاصطناعي / chatbot",
    "hi": "एआई सहायक/चैटबॉट",
    "ru": "AI-помощник/чат-бот",
    "tr": "Yapay zeka asistanı / sohbet robotu",
    "nl": "AI-assistent / chatbot",
    "pl": "Asystent AI / chatbot",
    "id": "Asisten AI/bot obrolan"
  },
  "AI-assisted SDLC transformation": {
    "es": "Transformación del SDLC asistida por IA",
    "pt": "Transformação do SDLC assistida por IA",
    "fr": "Transformation du SDLC assistée par l'IA",
    "de": "KI-gestützte SDLC-Transformation",
    "it": "Trasformazione SDLC assistita dall'IA",
    "zh": "AI 辅助的 SDLC 转型",
    "ja": "AI支援によるSDLC変革",
    "ko": "AI 지원 SDLC 전환",
    "ar": "تحول SDLC بمساعدة الذكاء الاصطناعي",
    "hi": "AI-सहायित SDLC परिवर्तन",
    "ru": "Трансформация SDLC с помощью ИИ",
    "tr": "YZ destekli SDLC dönüşümü",
    "nl": "AI-ondersteunde SDLC-transformatie",
    "pl": "Transformacja SDLC wspierana przez AI",
    "id": "Transformasi SDLC berbantuan AI"
  },
  "AI enablement for business operations performance": {
    "es": "Habilitación de IA para mejorar la performance operativa del negocio",
    "pt": "Capacitação em IA para melhorar a performance operacional do negócio",
    "fr": "Activation de l'IA pour améliorer la performance opérationnelle de l'entreprise",
    "de": "KI-Einführung zur Steigerung der operativen Unternehmensleistung",
    "it": "Abilitazione dell'IA per migliorare le prestazioni operative aziendali",
    "zh": "通过 AI 赋能提升企业运营绩效",
    "ja": "業務オペレーションのパフォーマンス向上のためのAI導入",
    "ko": "비즈니스 운영 성과 향상을 위한 AI 도입",
    "ar": "تمكين الذكاء الاصطناعي لتحسين أداء العمليات في الشركة",
    "hi": "व्यावसायिक परिचालन प्रदर्शन बढ़ाने के लिए AI सक्षमकरण",
    "ru": "Внедрение ИИ для повышения эффективности бизнес-операций",
    "tr": "İş operasyonu performansını artırmak için YZ etkinleştirme",
    "nl": "AI-inzet voor betere operationele bedrijfsprestaties",
    "pl": "Wdrożenie AI w celu poprawy efektywności operacyjnej firmy",
    "id": "Penerapan AI untuk meningkatkan kinerja operasional bisnis"
  },
  "Enterprise system integration": {
    "es": "Integración del sistema empresarial",
    "pt": "Integração de sistemas empresariais",
    "fr": "Intégration de systèmes d'entreprise",
    "de": "Integration von Unternehmenssystemen",
    "it": "Integrazione del sistema aziendale",
    "zh": "企业系统集成",
    "ja": "エンタープライズシステム統合",
    "ko": "엔터프라이즈 시스템 통합",
    "ar": "تكامل نظام المؤسسة",
    "hi": "उद्यम प्रणाली एकीकरण",
    "ru": "Интеграция корпоративных систем",
    "tr": "Kurumsal sistem entegrasyonu",
    "nl": "Integratie van bedrijfssystemen",
    "pl": "Integracja systemów korporacyjnych",
    "id": "Integrasi sistem perusahaan"
  },
  "Technical discovery / product strategy": {
    "es": "Descubrimiento técnico/estrategia de producto.",
    "pt": "Descoberta técnica/estratégia de produto",
    "fr": "Découverte technique / stratégie produit",
    "de": "Technische Entdeckung/Produktstrategie",
    "it": "Scoperta tecnica/strategia di prodotto",
    "zh": "技术发现/产品策略",
    "ja": "技術発掘・製品戦略",
    "ko": "기술발굴 / 제품전략",
    "ar": "الاكتشاف الفني/استراتيجية المنتج",
    "hi": "तकनीकी खोज/उत्पाद रणनीति",
    "ru": "Техническое открытие/стратегия продукта",
    "tr": "Teknik keşif / ürün stratejisi",
    "nl": "Technische ontdekking / productstrategie",
    "pl": "Odkrycie techniczne / strategia produktu",
    "id": "Penemuan teknis/strategi produk"
  },
  "Just an idea": {
    "es": "solo una idea",
    "pt": "Apenas uma ideia",
    "fr": "Juste une idée",
    "de": "Nur eine Idee",
    "it": "Solo un'idea",
    "zh": "只是一个想法",
    "ja": "ただのアイデア",
    "ko": "그냥 아이디어",
    "ar": "مجرد فكرة",
    "hi": "एक विचार है",
    "ru": "Просто идея",
    "tr": "Sadece bir fikir",
    "nl": "Het is maar een idee",
    "pl": "Tylko pomysł",
    "id": "Hanya sebuah ide"
  },
  "We have a business need but no technical definition yet": {
    "es": "Tenemos una necesidad comercial pero aún no hay una definición técnica.",
    "pt": "Temos uma necessidade comercial, mas ainda não temos uma definição técnica",
    "fr": "Nous avons un besoin métier mais pas encore de définition technique",
    "de": "Wir haben einen geschäftlichen Bedarf, aber noch keine technische Definition",
    "it": "Abbiamo un'esigenza aziendale ma non abbiamo ancora una definizione tecnica",
    "zh": "我们有业务需求，但还没有技术定义",
    "ja": "ビジネスニーズはあるが、技術的な定義はまだない",
    "ko": "비즈니스 요구사항은 있지만 아직 기술적 정의가 없습니다.",
    "ar": "لدينا حاجة تجارية ولكن ليس لدينا تعريف تقني بعد",
    "hi": "हमारी व्यावसायिक आवश्यकता तो है लेकिन अभी तक कोई तकनीकी परिभाषा नहीं है",
    "ru": "У нас есть бизнес-потребность, но пока нет технического определения",
    "tr": "İş ihtiyacımız var ama henüz teknik tanımı yok",
    "nl": "We hebben een zakelijke behoefte, maar nog geen technische definitie",
    "pl": "Mamy potrzebę biznesową, ale nie mamy jeszcze definicji technicznej",
    "id": "Kami memiliki kebutuhan bisnis tetapi belum ada definisi teknisnya"
  },
  "We have requirements or a brief": {
    "es": "Tenemos requisitos o un breve",
    "pt": "Temos requisitos ou um breve",
    "fr": "Nous avons des exigences ou un brief",
    "de": "Wir haben Anforderungen oder ein Briefing",
    "it": "Abbiamo dei requisiti o un brief",
    "zh": "我们有要求或简介",
    "ja": "要件または概要があります",
    "ko": "요구사항이나 브리핑이 있습니다.",
    "ar": "لدينا متطلبات أو موجزة",
    "hi": "हमारी आवश्यकताएं या संक्षिप्त विवरण हैं",
    "ru": "У нас есть требования или краткое описание",
    "tr": "Gereksinimlerimiz veya kısa bir açıklamamız var",
    "nl": "We hebben vereisten of een opdracht",
    "pl": "Mamy wymagania lub brief",
    "id": "Kami memiliki persyaratan atau penjelasan singkat"
  },
  "We have designs / Figma": {
    "es": "Tenemos diseños / Figma",
    "pt": "Temos desenhos / Figma",
    "fr": "Nous avons des dessins / Figma",
    "de": "Wir haben Designs / Figma",
    "it": "Abbiamo disegni / Figma",
    "zh": "我们有设计/ Figma",
    "ja": "デザインあります / Figma",
    "ko": "우리는 디자인을 가지고 있습니다 / Figma",
    "ar": "لدينا تصاميم / فيجما",
    "hi": "हमारे पास डिज़ाइन/फिग्मा हैं",
    "ru": "У нас есть дизайны / Фигма",
    "tr": "Tasarımlarımız var / Figma",
    "nl": "Wij hebben ontwerpen / Figma",
    "pl": "Posiadamy projekty / Figma",
    "id": "Kami memiliki desain / Figma"
  },
  "We have a prototype": {
    "es": "tenemos un prototipo",
    "pt": "Temos um protótipo",
    "fr": "Nous avons un prototype",
    "de": "Wir haben einen Prototyp",
    "it": "Abbiamo un prototipo",
    "zh": "我们有一个原型",
    "ja": "プロトタイプがあります",
    "ko": "우리는 프로토타입을 가지고 있습니다.",
    "ar": "لدينا نموذج أولي",
    "hi": "हमारे पास एक प्रोटोटाइप है",
    "ru": "У нас есть прототип",
    "tr": "Bir prototipimiz var",
    "nl": "We hebben een prototype",
    "pl": "Mamy prototyp",
    "id": "Kami memiliki prototipe"
  },
  "We have an MVP": {
    "es": "Tenemos un MVP",
    "pt": "Temos um MVP",
    "fr": "Nous avons un MVP",
    "de": "Wir haben einen MVP",
    "it": "Abbiamo un MVP",
    "zh": "我们有 MVP",
    "ja": "私たちにはMVPがいます",
    "ko": "우리에겐 MVP가 있다",
    "ar": "لدينا أفضل لاعب",
    "hi": "हमारे पास एक एमवीपी है",
    "ru": "У нас есть MVP",
    "tr": "Bir MVP'miz var",
    "nl": "Wij hebben een MVP",
    "pl": "Mamy MVP",
    "id": "Kami memiliki MVP"
  },
  "We have an existing product in production": {
    "es": "Tenemos un producto existente en producción.",
    "pt": "Temos um produto existente em produção",
    "fr": "Nous avons un produit existant en production",
    "de": "Wir haben ein bestehendes Produkt in Produktion",
    "it": "Abbiamo un prodotto esistente in produzione",
    "zh": "我们现有的产品正在生产中",
    "ja": "生産中の既存製品があります",
    "ko": "기존에 생산중인 제품이 있습니다",
    "ar": "لدينا منتج موجود في الإنتاج",
    "hi": "हमारे पास उत्पादन में एक मौजूदा उत्पाद है",
    "ru": "У нас есть существующий продукт в производстве",
    "tr": "Üretimde mevcut bir ürünümüz var",
    "nl": "Wij hebben een bestaand product in productie",
    "pl": "Mamy istniejący produkt w produkcji",
    "id": "Kami memiliki produk yang sudah ada dalam produksi"
  },
  "The project is blocked or underperforming": {
    "es": "El proyecto está bloqueado o tiene un rendimiento deficiente",
    "pt": "O projeto está bloqueado ou com baixo desempenho",
    "fr": "Le projet est bloqué ou sous-performant",
    "de": "Das Projekt ist blockiert oder weist eine unzureichende Leistung auf",
    "it": "Il progetto è bloccato o con prestazioni insufficienti",
    "zh": "项目被阻止或表现不佳",
    "ja": "プロジェクトがブロックされているか、パフォーマンスが低下しています",
    "ko": "프로젝트가 차단되었거나 성능이 저하되었습니다.",
    "ar": "المشروع محظور أو ضعيف الأداء",
    "hi": "प्रोजेक्ट अवरुद्ध है या ख़राब प्रदर्शन कर रहा है",
    "ru": "Проект заблокирован или неэффективен",
    "tr": "Proje engellendi veya düşük performans gösteriyor",
    "nl": "Het project is geblokkeerd of presteert ondermaats",
    "pl": "Projekt jest zablokowany lub działa słabo",
    "id": "Proyek diblokir atau berkinerja buruk"
  },
  "We need technical assessment before deciding": {
    "es": "Necesitamos asesoramiento técnico antes de decidir",
    "pt": "Precisamos de avaliação técnica antes de decidir",
    "fr": "Nous avons besoin d'une évaluation technique avant de décider",
    "de": "Wir benötigen eine technische Bewertung, bevor wir eine Entscheidung treffen",
    "it": "Abbiamo bisogno di una valutazione tecnica prima di decidere",
    "zh": "在决定之前我们需要进行技术评估",
    "ja": "決定する前に技術的な評価が必要です",
    "ko": "결정하기 전에 기술 평가가 필요합니다.",
    "ar": "نحن بحاجة إلى التقييم الفني قبل اتخاذ القرار",
    "hi": "निर्णय लेने से पहले हमें तकनीकी मूल्यांकन की आवश्यकता है",
    "ru": "Прежде чем принять решение, нам нужна техническая оценка",
    "tr": "Karar vermeden önce teknik değerlendirmeye ihtiyacımız var",
    "nl": "Voordat we een beslissing nemen, hebben we een technische beoordeling nodig",
    "pl": "Przed podjęciem decyzji potrzebujemy oceny technicznej",
    "id": "Kami memerlukan penilaian teknis sebelum mengambil keputusan"
  },
  "No, we need full delivery": {
    "es": "No, necesitamos entrega completa.",
    "pt": "Não, precisamos de entrega completa",
    "fr": "Non, nous avons besoin d'une livraison complète",
    "de": "Nein, wir benötigen eine vollständige Lieferung",
    "it": "No, abbiamo bisogno della consegna completa",
    "zh": "不，我们需要全程交付",
    "ja": "いいえ、完全な納品が必要です",
    "ko": "아니요, 전체 배송이 필요합니다",
    "ar": "لا، نحن بحاجة إلى التسليم الكامل",
    "hi": "नहीं, हमें पूर्ण डिलीवरी की आवश्यकता है",
    "ru": "Нет, нам нужна полная доставка",
    "tr": "Hayır, tam teslimata ihtiyacımız var",
    "nl": "Nee, we hebben een volledige levering nodig",
    "pl": "Nie, potrzebujemy pełnej dostawy",
    "id": "Tidak, kami memerlukan pengiriman penuh"
  },
  "Yes, but we need external support": {
    "es": "Sí, pero necesitamos apoyo externo.",
    "pt": "Sim, mas precisamos de apoio externo",
    "fr": "Oui, mais nous avons besoin d'un soutien extérieur",
    "de": "Ja, aber wir brauchen externe Unterstützung",
    "it": "Sì, ma abbiamo bisogno di un sostegno esterno",
    "zh": "是的，但我们需要外部支持",
    "ja": "はい、しかし外部のサポートが必要です",
    "ko": "예, 하지만 외부 지원이 필요합니다",
    "ar": "نعم، ولكننا بحاجة إلى دعم خارجي",
    "hi": "हाँ, लेकिन हमें बाहरी समर्थन की आवश्यकता है",
    "ru": "Да, но нам нужна внешняя поддержка",
    "tr": "Evet ama dışarıdan desteğe ihtiyacımız var",
    "nl": "Ja, maar we hebben externe steun nodig",
    "pl": "Tak, ale potrzebujemy wsparcia zewnętrznego",
    "id": "Ya, tapi kami memerlukan dukungan eksternal"
  },
  "Yes, we need architecture / technical leadership": {
    "es": "Sí, necesitamos arquitectura/liderazgo técnico.",
    "pt": "Sim, precisamos de arquitetura/liderança técnica",
    "fr": "Oui, nous avons besoin d'un leadership architectural/technique",
    "de": "Ja, wir brauchen Architektur/technische Führung",
    "it": "Sì, abbiamo bisogno di leadership architettonica/tecnica",
    "zh": "是的，我们需要架构/技术领导力",
    "ja": "はい、アーキテクチャ/技術的なリーダーシップが必要です",
    "ko": "예, 아키텍처/기술 리더십이 필요합니다.",
    "ar": "نعم، نحن بحاجة إلى الهندسة المعمارية / القيادة الفنية",
    "hi": "हाँ, हमें वास्तुकला/तकनीकी नेतृत्व की आवश्यकता है",
    "ru": "Да, нам нужно архитектурное/техническое лидерство",
    "tr": "Evet, mimariye/teknik liderliğe ihtiyacımız var",
    "nl": "Ja, we hebben architectuur/technisch leiderschap nodig",
    "pl": "Tak, potrzebujemy przywództwa architektonicznego/technicznego",
    "id": "Ya, kita membutuhkan kepemimpinan arsitektur/teknis"
  },
  "Yes, we need mobile specialists": {
    "es": "Sí, necesitamos especialistas móviles.",
    "pt": "Sim, precisamos de especialistas em dispositivos móveis",
    "fr": "Oui, nous avons besoin de spécialistes mobiles",
    "de": "Ja, wir brauchen mobile Spezialisten",
    "it": "Sì, abbiamo bisogno di specialisti della telefonia mobile",
    "zh": "是的，我们需要移动专家",
    "ja": "はい、モバイルのスペシャリストが必要です",
    "ko": "예, 모바일 전문가가 필요합니다",
    "ar": "نعم نحتاج متخصصين في مجال الجوال",
    "hi": "हाँ, हमें मोबाइल विशेषज्ञों की आवश्यकता है",
    "ru": "Да, нам нужны мобильные специалисты",
    "tr": "Evet, mobil uzmanlara ihtiyacımız var",
    "nl": "Ja, we hebben mobiele specialisten nodig",
    "pl": "Tak, potrzebujemy mobilnych specjalistów",
    "id": "Ya, kami memerlukan spesialis seluler"
  },
  "Yes, we need backend/cloud specialists": {
    "es": "Sí, necesitamos especialistas en backend/nube",
    "pt": "Sim, precisamos de especialistas em back-end/nuvem",
    "fr": "Oui, nous avons besoin de spécialistes backend/cloud",
    "de": "Ja, wir brauchen Backend-/Cloud-Spezialisten",
    "it": "Sì, abbiamo bisogno di specialisti di backend/cloud",
    "zh": "是的，我们需要后端/云专家",
    "ja": "はい、バックエンド/クラウドのスペシャリストが必要です",
    "ko": "예, 백엔드/클라우드 전문가가 필요합니다",
    "ar": "نعم، نحن بحاجة إلى متخصصين في الواجهة الخلفية/السحابة",
    "hi": "हाँ, हमें बैकएंड/क्लाउड विशेषज्ञों की आवश्यकता है",
    "ru": "Да, нам нужны специалисты по бэкенду/облаку",
    "tr": "Evet, arka uç/bulut uzmanlarına ihtiyacımız var",
    "nl": "Ja, we hebben backend/cloudspecialisten nodig",
    "pl": "Tak, potrzebujemy specjalistów od backendu/chmury",
    "id": "Ya, kami membutuhkan spesialis backend/cloud"
  },
  "Yes, we need AI/LLM expertise": {
    "es": "Sí, necesitamos experiencia en IA/LLM",
    "pt": "Sim, precisamos de experiência em AI/LLM",
    "fr": "Oui, nous avons besoin d'une expertise AI/LLM",
    "de": "Ja, wir brauchen KI/LLM-Expertise",
    "it": "Sì, abbiamo bisogno di competenze AI/LLM",
    "zh": "是的，我们需要 AI/LLM 专业知识",
    "ja": "はい、AI/LLM の専門知識が必要です",
    "ko": "예, AI/LLM 전문 지식이 필요합니다",
    "ar": "نعم، نحن بحاجة إلى خبرة في الذكاء الاصطناعي/LLM",
    "hi": "हां, हमें एआई/एलएलएम विशेषज्ञता की आवश्यकता है",
    "ru": "Да, нам нужен опыт AI/LLM",
    "tr": "Evet, AI/LLM uzmanlığına ihtiyacımız var",
    "nl": "Ja, we hebben AI/LLM-expertise nodig",
    "pl": "Tak, potrzebujemy wiedzy specjalistycznej w zakresie AI/LLM",
    "id": "Ya, kami membutuhkan keahlian AI/LLM"
  },
  "Yes, but the project is blocked": {
    "es": "Sí, pero el proyecto está bloqueado.",
    "pt": "Sim, mas o projeto está bloqueado",
    "fr": "Oui, mais le projet est bloqué",
    "de": "Ja, aber das Projekt ist blockiert",
    "it": "Sì, ma il progetto è bloccato",
    "zh": "是的，但该项目被阻止",
    "ja": "はい、しかしプロジェクトはブロックされています",
    "ko": "예, 하지만 프로젝트가 차단되었습니다",
    "ar": "نعم، ولكن المشروع محظور",
    "hi": "हाँ, लेकिन परियोजना अवरुद्ध है",
    "ru": "Да, но проект заблокирован",
    "tr": "Evet, ancak proje engellendi",
    "nl": "Ja, maar het project is geblokkeerd",
    "pl": "Tak, ale projekt jest zablokowany",
    "id": "Ya, tetapi proyek tersebut diblokir"
  },
  "We work with vendors and need independent assessment": {
    "es": "Trabajamos con proveedores y necesitamos una evaluación independiente.",
    "pt": "Trabalhamos com fornecedores e precisamos de avaliação independente",
    "fr": "Nous travaillons avec des fournisseurs et avons besoin d'une évaluation indépendante",
    "de": "Wir arbeiten mit Anbietern zusammen und benötigen eine unabhängige Bewertung",
    "it": "Collaboriamo con i fornitori e necessitiamo di una valutazione indipendente",
    "zh": "我们与供应商合作，需要独立评估",
    "ja": "私たちはベンダーと協力しているため、独立した評価が必要です",
    "ko": "공급업체와 협력하고 있으며 독립적인 평가가 필요합니다.",
    "ar": "نحن نعمل مع البائعين ونحتاج إلى تقييم مستقل",
    "hi": "हम विक्रेताओं के साथ काम करते हैं और स्वतंत्र मूल्यांकन की आवश्यकता है",
    "ru": "Мы работаем с вендорами и нуждаемся в независимой оценке",
    "tr": "Satıcılarla çalışıyoruz ve bağımsız değerlendirmeye ihtiyacımız var",
    "nl": "Wij werken samen met leveranciers en hebben een onafhankelijke beoordeling nodig",
    "pl": "Współpracujemy z dostawcami i potrzebujemy niezależnej oceny",
    "id": "Kami bekerja dengan vendor dan memerlukan penilaian independen"
  },
  "We are not sure": {
    "es": "no estamos seguros",
    "pt": "Não temos certeza",
    "fr": "Nous ne sommes pas sûrs",
    "de": "Wir sind uns nicht sicher",
    "it": "Non ne siamo sicuri",
    "zh": "我们不确定",
    "ja": "よくわかりません",
    "ko": "우리는 확실하지 않습니다",
    "ar": "نحن لسنا متأكدين",
    "hi": "हमें यकीन नहीं है",
    "ru": "Мы не уверены",
    "tr": "Emin değiliz",
    "nl": "We zijn er niet zeker van",
    "pl": "Nie jesteśmy pewni",
    "id": "Kami tidak yakin"
  },
  "Cloud infrastructure": {
    "es": "Infraestructura de la nube",
    "pt": "Infraestrutura em nuvem",
    "fr": "Infrastructure cloud",
    "de": "Cloud-Infrastruktur",
    "it": "Infrastruttura cloud",
    "zh": "云基础设施",
    "ja": "クラウドインフラストラクチャ",
    "ko": "클라우드 인프라",
    "ar": "البنية التحتية السحابية",
    "hi": "क्लाउड इंफ्रास्ट्रक्चर",
    "ru": "Облачная инфраструктура",
    "tr": "Bulut altyapısı",
    "nl": "Cloud-infrastructuur",
    "pl": "Infrastruktura chmurowa",
    "id": "Infrastruktur awan"
  },
  "System integration": {
    "es": "Integración del sistema",
    "pt": "Integração de sistema",
    "fr": "Intégration du système",
    "de": "Systemintegration",
    "it": "Integrazione del sistema",
    "zh": "系统集成",
    "ja": "システム統合",
    "ko": "시스템 통합",
    "ar": "تكامل النظام",
    "hi": "सिस्टम एकीकरण",
    "ru": "Системная интеграция",
    "tr": "Sistem entegrasyonu",
    "nl": "Systeemintegratie",
    "pl": "Integracja systemu",
    "id": "Integrasi sistem"
  },
  "Databases": {
    "es": "Bases de datos",
    "pt": "Bancos de dados",
    "fr": "Bases de données",
    "de": "Datenbanken",
    "it": "Database",
    "zh": "数据库",
    "ja": "データベース",
    "ko": "데이터베이스",
    "ar": "قواعد البيانات",
    "hi": "डेटाबेस",
    "ru": "Базы данных",
    "tr": "Veritabanları",
    "nl": "Databases",
    "pl": "Bazy danych",
    "id": "Basis Data"
  },
  "Authentication / SSO": {
    "es": "Autenticación/SSO",
    "pt": "Autenticação/SSO",
    "fr": "Authentification / SSO",
    "de": "Authentifizierung/SSO",
    "it": "Autenticazione/SSO",
    "zh": "身份验证/单点登录",
    "ja": "認証/SSO",
    "ko": "인증/SSO",
    "ar": "المصادقة / تسجيل الدخول الموحد",
    "hi": "प्रमाणीकरण/एसएसओ",
    "ru": "Аутентификация/Единый вход",
    "tr": "Kimlik doğrulama / SSO",
    "nl": "Authenticatie/SSO",
    "pl": "Uwierzytelnianie/SSO",
    "id": "Otentikasi / SSO"
  },
  "DevOps / CI-CD": {
    "es": "DevOps/CI-CD",
    "pt": "DevOps/CI-CD",
    "fr": "DevOps / CI-CD",
    "de": "DevOps / CI-CD",
    "it": "DevOps/CI-CD",
    "zh": "DevOps / CI-CD",
    "ja": "DevOps / CI-CD",
    "ko": "DevOps/CI-CD",
    "ar": "عمليات التطوير / CI-CD",
    "hi": "डेवऑप्स/सीआई-सीडी",
    "ru": "DevOps/CI-CD",
    "tr": "DevOps / CI-CD",
    "nl": "DevOps/CI-CD",
    "pl": "DevOps/CI-CD",
    "id": "DevOps / CI-CD"
  },
  "Monitoring / observability": {
    "es": "Monitoreo / observabilidad",
    "pt": "Monitoramento/observabilidade",
    "fr": "Surveillance / observabilité",
    "de": "Überwachung / Beobachtbarkeit",
    "it": "Monitoraggio/osservabilità",
    "zh": "监控/可观察性",
    "ja": "監視/可観測性",
    "ko": "모니터링 / 관찰 가능성",
    "ar": "الرصد/الملاحظة",
    "hi": "निगरानी/अवलोकन",
    "ru": "Мониторинг/наблюдаемость",
    "tr": "İzleme / gözlemlenebilirlik",
    "nl": "Monitoring / waarneembaarheid",
    "pl": "Monitorowanie / obserwowalność",
    "id": "Pemantauan / observasi"
  },
  "AI / LLM integrations": {
    "es": "Integraciones de IA/LLM",
    "pt": "Integrações AI / LLM",
    "fr": "Intégrations IA / LLM",
    "de": "KI-/LLM-Integrationen",
    "it": "Integrazioni AI/LLM",
    "zh": "人工智能/法学硕士整合",
    "ja": "AI / LLM の統合",
    "ko": "AI/LLM 통합",
    "ar": "تكامل الذكاء الاصطناعي / LLM",
    "hi": "एआई/एलएलएम एकीकरण",
    "ru": "Интеграция AI/LLM",
    "tr": "AI / LLM entegrasyonları",
    "nl": "AI / LLM-integraties",
    "pl": "Integracje AI/LLM",
    "id": "Integrasi AI / LLM"
  },
  "AI assistants / chatbots": {
    "es": "Asistentes de IA/chatbots",
    "pt": "Assistentes de IA / chatbots",
    "fr": "Assistants IA / chatbots",
    "de": "KI-Assistenten / Chatbots",
    "it": "Assistenti AI/chatbot",
    "zh": "人工智能助手/聊天机器人",
    "ja": "AIアシスタント/チャットボット",
    "ko": "AI 비서/챗봇",
    "ar": "مساعدو الذكاء الاصطناعي / روبوتات الدردشة",
    "hi": "एआई सहायक/चैटबॉट",
    "ru": "AI-помощники/чат-боты",
    "tr": "Yapay zeka asistanları/sohbet robotları",
    "nl": "AI-assistenten / chatbots",
    "pl": "Asystenci AI / chatboty",
    "id": "Asisten AI / chatbot"
  },
  "AI workflow automation": {
    "es": "Automatización del flujo de trabajo de IA",
    "pt": "Automação do fluxo de trabalho de IA",
    "fr": "Automatisation du flux de travail de l'IA",
    "de": "KI-Workflow-Automatisierung",
    "it": "Automazione del flusso di lavoro basata sull'intelligenza artificiale",
    "zh": "AI工作流程自动化",
    "ja": "AI ワークフローの自動化",
    "ko": "AI 워크플로 자동화",
    "ar": "أتمتة سير العمل بالذكاء الاصطناعي",
    "hi": "एआई वर्कफ़्लो स्वचालन",
    "ru": "Автоматизация рабочих процессов с помощью ИИ",
    "tr": "Yapay zeka iş akışı otomasyonu",
    "nl": "Automatisering van AI-workflows",
    "pl": "Automatyzacja przepływu pracy AI",
    "id": "Otomatisasi alur kerja AI"
  },
  "Document processing": {
    "es": "Procesamiento de documentos",
    "pt": "Processamento de documentos",
    "fr": "Traitement des documents",
    "de": "Dokumentenverarbeitung",
    "it": "Elaborazione dei documenti",
    "zh": "文件处理",
    "ja": "文書処理",
    "ko": "문서 처리",
    "ar": "معالجة المستندات",
    "hi": "दस्तावेज़ प्रसंस्करण",
    "ru": "Обработка документов",
    "tr": "Belge işleme",
    "nl": "Documentverwerking",
    "pl": "Przetwarzanie dokumentów",
    "id": "Pemrosesan dokumen"
  },
  "Recommendation engines": {
    "es": "Motores de recomendación",
    "pt": "Mecanismos de recomendação",
    "fr": "Moteurs de recommandation",
    "de": "Empfehlungsmaschinen",
    "it": "Motori di raccomandazione",
    "zh": "推荐引擎",
    "ja": "レコメンデーションエンジン",
    "ko": "추천 엔진",
    "ar": "محركات التوصية",
    "hi": "सिफ़ारिश इंजन",
    "ru": "Рекомендательные системы",
    "tr": "Öneri motorları",
    "nl": "Aanbeveling motoren",
    "pl": "Silniki rekomendacji",
    "id": "Mesin rekomendasi"
  },
  "Content generation": {
    "es": "Generación de contenido",
    "pt": "Geração de conteúdo",
    "fr": "Génération de contenu",
    "de": "Content-Generierung",
    "it": "Generazione di contenuti",
    "zh": "内容生成",
    "ja": "コンテンツの生成",
    "ko": "콘텐츠 생성",
    "ar": "توليد المحتوى",
    "hi": "सामग्री निर्माण",
    "ru": "Генерация контента",
    "tr": "İçerik oluşturma",
    "nl": "Het genereren van inhoud",
    "pl": "Generowanie treści",
    "id": "Pembuatan konten"
  },
  "Retrieval-augmented generation / RAG": {
    "es": "Generación aumentada de recuperación / RAG",
    "pt": "Geração aumentada de recuperação / RAG",
    "fr": "Génération augmentée par récupération / RAG",
    "de": "Retrieval-Augmented Generation / RAG",
    "it": "Generazione aumentata di recupero / RAG",
    "zh": "检索增强生成/RAG",
    "ja": "検索拡張生成 / RAG",
    "ko": "검색증강생성 / RAG",
    "ar": "استرجاع الجيل المعزز / RAG",
    "hi": "पुनर्प्राप्ति-संवर्धित पीढ़ी / RAG",
    "ru": "Генерация с расширенным поиском / RAG",
    "tr": "Almayla artırılmış nesil / RAG",
    "nl": "Retrieval-augmented generatie / RAG",
    "pl": "Generacja wzmocniona wyszukiwaniem / RAG",
    "id": "Generasi yang ditambah pengambilan / RAG"
  },
  "Internal knowledge assistants": {
    "es": "Asistentes de conocimiento interno.",
    "pt": "Assistentes de conhecimento interno",
    "fr": "Assistants de connaissances internes",
    "de": "Interne Wissensassistenten",
    "it": "Assistenti interni della conoscenza",
    "zh": "内部知识助理",
    "ja": "社内ナレッジアシスタント",
    "ko": "내부 지식 보조원",
    "ar": "مساعدو المعرفة الداخلية",
    "hi": "आंतरिक ज्ञान सहायक",
    "ru": "Внутренние помощники по знаниям",
    "tr": "Dahili bilgi asistanları",
    "nl": "Interne kennisassistenten",
    "pl": "Wewnętrzni asystenci wiedzy",
    "id": "Asisten pengetahuan internal"
  },
  "Customer-facing AI": {
    "es": "IA orientada al cliente",
    "pt": "IA voltada para o cliente",
    "fr": "IA orientée client",
    "de": "Kundenorientierte KI",
    "it": "Intelligenza artificiale rivolta al cliente",
    "zh": "面向客户的人工智能",
    "ja": "顧客対応 AI",
    "ko": "고객 대면 AI",
    "ar": "الذكاء الاصطناعي الذي يواجه العملاء",
    "hi": "ग्राहक-सामना करने वाला AI",
    "ru": "ИИ, работающий с клиентами",
    "tr": "Müşteriye yönelik yapay zeka",
    "nl": "Klantgerichte AI",
    "pl": "Sztuczna inteligencja skierowana do klienta",
    "id": "AI yang berhadapan dengan pelanggan"
  },
  "Immediately / urgent": {
    "es": "Inmediatamente / urgente",
    "pt": "Imediatamente / urgente",
    "fr": "Immédiatement / urgent",
    "de": "Sofort / dringend",
    "it": "Immediato/urgente",
    "zh": "立即/紧急",
    "ja": "すぐに/緊急",
    "ko": "즉시/긴급",
    "ar": "عاجل / عاجل",
    "hi": "तत्काल/अत्यावश्यक",
    "ru": "Немедленно/срочно",
    "tr": "Derhal / acil",
    "nl": "Onmiddellijk/dringend",
    "pl": "Natychmiast / pilne",
    "id": "Segera/mendesak"
  },
  "Within the next month": {
    "es": "Dentro del próximo mes",
    "pt": "No próximo mês",
    "fr": "Dans le mois prochain",
    "de": "Innerhalb des nächsten Monats",
    "it": "Entro il prossimo mese",
    "zh": "下个月内",
    "ja": "翌月以内に",
    "ko": "다음 달 이내",
    "ar": "خلال الشهر القادم",
    "hi": "अगले महीने के भीतर",
    "ru": "В течение следующего месяца",
    "tr": "Gelecek ay içinde",
    "nl": "Binnen de volgende maand",
    "pl": "W ciągu najbliższego miesiąca",
    "id": "Dalam bulan berikutnya"
  },
  "In the next 2-3 months": {
    "es": "En los próximos 2-3 meses",
    "pt": "Nos próximos 2-3 meses",
    "fr": "Dans les 2-3 prochains mois",
    "de": "In den nächsten 2-3 Monaten",
    "it": "Nei prossimi 2-3 mesi",
    "zh": "未来2-3个月内",
    "ja": "今後 2 ～ 3 か月以内に",
    "ko": "앞으로 2~3개월 안에",
    "ar": "في 2-3 أشهر القادمة",
    "hi": "अगले 2-3 महीनों में",
    "ru": "В ближайшие 2-3 месяца",
    "tr": "Önümüzdeki 2-3 ay içinde",
    "nl": "In de komende 2-3 maanden",
    "pl": "W ciągu najbliższych 2-3 miesięcy",
    "id": "Dalam 2-3 bulan ke depan"
  },
  "This quarter": {
    "es": "este trimestre",
    "pt": "Este trimestre",
    "fr": "Ce trimestre",
    "de": "Dieses Quartal",
    "it": "Questo trimestre",
    "zh": "本季度",
    "ja": "今四半期",
    "ko": "이번 분기",
    "ar": "هذا الربع",
    "hi": "इस तिमाही",
    "ru": "В этом квартале",
    "tr": "Bu çeyrek",
    "nl": "Dit kwartaal",
    "pl": "W tym kwartale",
    "id": "Kuartal ini"
  },
  "This year": {
    "es": "este año",
    "pt": "Este ano",
    "fr": "Cette année",
    "de": "Dieses Jahr",
    "it": "Quest'anno",
    "zh": "今年",
    "ja": "今年",
    "ko": "올해",
    "ar": "هذا العام",
    "hi": "इस साल",
    "ru": "В этом году",
    "tr": "Bu yıl",
    "nl": "Dit jaar",
    "pl": "W tym roku",
    "id": "tahun ini"
  },
  "We are planning for next year": {
    "es": "Estamos planeando para el próximo año.",
    "pt": "Estamos planejando para o próximo ano",
    "fr": "Nous planifions pour l'année prochaine",
    "de": "Wir planen für nächstes Jahr",
    "it": "Stiamo programmando per il prossimo anno",
    "zh": "我们正在计划明年",
    "ja": "来年も計画中です",
    "ko": "우리는 내년을 계획하고 있습니다",
    "ar": "نحن نخطط للعام المقبل",
    "hi": "हम अगले साल के लिए योजना बना रहे हैं",
    "ru": "Планируем на следующий год",
    "tr": "Gelecek yıl için plan yapıyoruz",
    "nl": "Wij maken plannen voor volgend jaar",
    "pl": "Planujemy na przyszły rok",
    "id": "Kami berencana untuk tahun depan"
  },
  "We are only exploring options": {
    "es": "Sólo estamos explorando opciones.",
    "pt": "Estamos apenas explorando opções",
    "fr": "Nous explorons seulement les options",
    "de": "Wir prüfen lediglich Optionen",
    "it": "Stiamo solo esplorando le opzioni",
    "zh": "我们只是在探索选择",
    "ja": "私たちは選択肢を模索しているだけです",
    "ko": "우리는 옵션만을 탐색하고 있습니다",
    "ar": "نحن نستكشف الخيارات فقط",
    "hi": "हम केवल विकल्प तलाश रहे हैं।'",
    "ru": "Мы только рассматриваем варианты",
    "tr": "Yalnızca seçenekleri araştırıyoruz",
    "nl": "We onderzoeken alleen opties",
    "pl": "Badamy tylko opcje",
    "id": "Kami hanya menjajaki opsi"
  },
  "Fixed-scope project": {
    "es": "Proyecto de alcance fijo",
    "pt": "Projeto de escopo fixo",
    "fr": "Projet à portée fixe",
    "de": "Projekt mit festem Umfang",
    "it": "Progetto a portata fissa",
    "zh": "固定范围项目",
    "ja": "固定スコープのプロジェクト",
    "ko": "고정 범위 프로젝트",
    "ar": "مشروع ذو نطاق ثابت",
    "hi": "फिक्स्ड-स्कोप प्रोजेक्ट",
    "ru": "Проект с фиксированным объемом",
    "tr": "Sabit kapsamlı proje",
    "nl": "Project met een vaste scope",
    "pl": "Projekt o stałym zakresie",
    "id": "Proyek dengan cakupan tetap"
  },
  "Discovery phase before development": {
    "es": "Fase de descubrimiento antes del desarrollo.",
    "pt": "Fase de descoberta antes do desenvolvimento",
    "fr": "Phase de découverte avant développement",
    "de": "Entdeckungsphase vor der Entwicklung",
    "it": "Fase di scoperta prima dello sviluppo",
    "zh": "开发前的发现阶段",
    "ja": "開発前の発見段階",
    "ko": "개발 전 발견 단계",
    "ar": "مرحلة الاكتشاف قبل التطوير",
    "hi": "विकास से पहले खोज चरण",
    "ru": "Этап открытия перед разработкой",
    "tr": "Geliştirme öncesi keşif aşaması",
    "nl": "Ontdekkingsfase vóór ontwikkeling",
    "pl": "Faza odkrywania przed rozwojem",
    "id": "Fase penemuan sebelum pengembangan"
  },
  "MVP development": {
    "es": "Desarrollo de MVP",
    "pt": "Desenvolvimento de MVP",
    "fr": "Développement MVP",
    "de": "MVP-Entwicklung",
    "it": "Sviluppo MVP",
    "zh": "MVP开发",
    "ja": "MVPの開発",
    "ko": "MVP 개발",
    "ar": "تطوير أفضل لاعب",
    "hi": "एमवीपी विकास",
    "ru": "разработка MVP",
    "tr": "MVP geliştirme",
    "nl": "MVP-ontwikkeling",
    "pl": "Rozwój MVP",
    "id": "pengembangan MVP"
  },
  "Long-term product development": {
    "es": "Desarrollo de productos a largo plazo",
    "pt": "Desenvolvimento de produtos a longo prazo",
    "fr": "Développement de produits à long terme",
    "de": "Langfristige Produktentwicklung",
    "it": "Sviluppo del prodotto a lungo termine",
    "zh": "长期产品开发",
    "ja": "長期にわたる製品開発",
    "ko": "장기적인 제품 개발",
    "ar": "تطوير المنتجات على المدى الطويل",
    "hi": "दीर्घकालिक उत्पाद विकास",
    "ru": "Долгосрочная разработка продукта",
    "tr": "Uzun vadeli ürün geliştirme",
    "nl": "Productontwikkeling op lange termijn",
    "pl": "Długoterminowy rozwój produktu",
    "id": "Pengembangan produk jangka panjang"
  },
  "Time & materials": {
    "es": "Tiempo y materiales",
    "pt": "Tempo e materiais",
    "fr": "Temps et matériaux",
    "de": "Zeit & Materialien",
    "it": "Tempo e materiali",
    "zh": "时间和材料",
    "ja": "時間と材料",
    "ko": "시간 및 재료",
    "ar": "الوقت والمواد",
    "hi": "समय एवं सामग्री",
    "ru": "Время и материалы",
    "tr": "Zaman ve materyaller",
    "nl": "Tijd & materialen",
    "pl": "Czas i materiały",
    "id": "Waktu & bahan"
  },
  "Technical consultancy": {
    "es": "Consultoría técnica",
    "pt": "Consultoria técnica",
    "fr": "Conseil technique",
    "de": "Technische Beratung",
    "it": "Consulenza tecnica",
    "zh": "技术咨询",
    "ja": "技術コンサルティング",
    "ko": "기술 컨설팅",
    "ar": "الاستشارات الفنية",
    "hi": "तकनीकी परामर्श",
    "ru": "Техническая консультация",
    "tr": "Teknik danışmanlık",
    "nl": "Technisch advies",
    "pl": "Doradztwo techniczne",
    "id": "Konsultasi teknis"
  },
  "Staff augmentation": {
    "es": "aumento de personal",
    "pt": "Aumento de pessoal",
    "fr": "Augmentation du personnel",
    "de": "Personalaufstockung",
    "it": "Aumento del personale",
    "zh": "人员扩充",
    "ja": "スタッフの増強",
    "ko": "직원 증원",
    "ar": "زيادة الموظفين",
    "hi": "स्टाफ वृद्धि",
    "ru": "Увеличение штата",
    "tr": "Personel artışı",
    "nl": "Personeelsuitbreiding",
    "pl": "Zwiększenie personelu",
    "id": "Penambahan staf"
  },
  "Monthly retainer": {
    "es": "anticipo mensual",
    "pt": "Retentor mensal",
    "fr": "Acompte mensuel",
    "de": "Monatlicher Vorschuss",
    "it": "Acconto mensile",
    "zh": "每月预付金",
    "ja": "月額リテイナー",
    "ko": "월간 리테이너",
    "ar": "التجنيب الشهري",
    "hi": "मासिक अनुचर",
    "ru": "Ежемесячный гонорар",
    "tr": "Aylık ücret",
    "nl": "Maandelijkse provisie",
    "pl": "Miesięczny zasiłek",
    "id": "Punggawa bulanan"
  },
  "Email": {
    "es": "Correo electrónico",
    "pt": "E-mail",
    "fr": "E-mail",
    "de": "E-Mail",
    "it": "E-mail",
    "zh": "电子邮件",
    "ja": "電子メール",
    "ko": "이메일",
    "ar": "بريد إلكتروني",
    "hi": "ईमेल",
    "ru": "Электронная почта",
    "tr": "E-posta",
    "nl": "E-mail",
    "pl": "E-mail",
    "id": "E-mail"
  },
  "Phone": {
    "es": "Teléfono",
    "pt": "Telefone",
    "fr": "Téléphone",
    "de": "Telefon",
    "it": "Telefono",
    "zh": "电话",
    "ja": "電話",
    "ko": "핸드폰",
    "ar": "هاتف",
    "hi": "फ़ोन",
    "ru": "Телефон",
    "tr": "Telefon",
    "nl": "Telefoon",
    "pl": "Telefon",
    "id": "Telepon"
  },
  "WhatsApp": {
    "es": "WhatsApp",
    "pt": "WhatsApp",
    "fr": "WhatsApp",
    "de": "WhatsApp",
    "it": "Whatsapp",
    "zh": "WhatsApp",
    "ja": "ワッツアップ",
    "ko": "왓츠앱",
    "ar": "واتساب",
    "hi": "WhatsApp",
    "ru": "WhatsApp",
    "tr": "WhatsApp",
    "nl": "WhatsAppen",
    "pl": "WhatsApp",
    "id": "Ada apa"
  },
  "Video call": {
    "es": "Videollamada",
    "pt": "Videochamada",
    "fr": "Appel vidéo",
    "de": "Videoanruf",
    "it": "Videochiamata",
    "zh": "视频电话",
    "ja": "ビデオ通話",
    "ko": "영상통화",
    "ar": "مكالمة فيديو",
    "hi": "वीडियो कॉल",
    "ru": "Видеозвонок",
    "tr": "Video görüşmesi",
    "nl": "Videogesprek",
    "pl": "Rozmowa wideo",
    "id": "Panggilan video"
  }
};

const industryGroupLabels = {
  "Financial and regulated": {
    es: "Financiera y regulada",
    pt: "Financeira e regulada",
    fr: "Finance et secteurs régulés",
    de: "Finanzen und regulierte Branchen",
    it: "Finanza e settori regolamentati",
    zh: "金融与监管行业",
    ja: "金融・規制分野",
    ko: "금융 및 규제 산업",
    ar: "القطاع المالي والقطاعات المنظمة",
    hi: "वित्त और विनियमित क्षेत्र",
    ru: "Финансовая и регулируемая сфера",
    tr: "Finans ve regüle sektörler",
    nl: "Financieel en gereguleerd",
    pl: "Finanse i sektory regulowane",
    id: "Keuangan dan sektor teregulasi",
  },
  "Commerce and services": {
    es: "Comercio y servicios",
    pt: "Comércio e serviços",
    fr: "Commerce et services",
    de: "Handel und Dienstleistungen",
    it: "Commercio e servizi",
    zh: "商业与服务",
    ja: "商業・サービス",
    ko: "상거래 및 서비스",
    ar: "التجارة والخدمات",
    hi: "वाणिज्य और सेवाएँ",
    ru: "Коммерция и услуги",
    tr: "Ticaret ve hizmetler",
    nl: "Handel en diensten",
    pl: "Handel i usługi",
    id: "Perdagangan dan layanan",
  },
  "Health, education and social impact": {
    es: "Salud, educación e impacto social",
    pt: "Saúde, educação e impacto social",
    fr: "Santé, éducation et impact social",
    de: "Gesundheit, Bildung und soziale Wirkung",
    it: "Salute, istruzione e impatto sociale",
    zh: "健康、教育与社会影响",
    ja: "ヘルスケア・教育・社会的インパクト",
    ko: "헬스케어·교육·사회적 영향",
    ar: "الصحة والتعليم والأثر الاجتماعي",
    hi: "स्वास्थ्य, शिक्षा और सामाजिक प्रभाव",
    ru: "Здравоохранение, образование и социальное влияние",
    tr: "Sağlık, eğitim ve sosyal etki",
    nl: "Gezondheid, onderwijs en sociale impact",
    pl: "Zdrowie, edukacja i wpływ społeczny",
    id: "Kesehatan, pendidikan, dan dampak sosial",
  },
  "Technology and media": {
    es: "Tecnología y medios",
    pt: "Tecnologia e mídia",
    fr: "Technologie et médias",
    de: "Technologie und Medien",
    it: "Tecnologia e media",
    zh: "科技与媒体",
    ja: "テクノロジー・メディア",
    ko: "기술 및 미디어",
    ar: "التقنية والإعلام",
    hi: "प्रौद्योगिकी और मीडिया",
    ru: "Технологии и медиа",
    tr: "Teknoloji ve medya",
    nl: "Technologie en media",
    pl: "Technologia i media",
    id: "Teknologi dan media",
  },
  "Industrial and enterprise": {
    es: "Industrial y corporativa",
    pt: "Industrial e corporativo",
    fr: "Industriel et entreprise",
    de: "Industrie und Unternehmen",
    it: "Industriale e enterprise",
    zh: "工业与企业",
    ja: "産業・エンタープライズ",
    ko: "산업 및 엔터프라이즈",
    ar: "الصناعي والمؤسسي",
    hi: "औद्योगिक और एंटरप्राइज़",
    ru: "Промышленность и корпоративный сектор",
    tr: "Endüstriyel ve kurumsal",
    nl: "Industrieel en enterprise",
    pl: "Przemysł i enterprise",
    id: "Industri dan enterprise",
  },
  Other: {
    es: "Otras",
    pt: "Outros",
    fr: "Autres",
    de: "Andere",
    it: "Altro",
    zh: "其他",
    ja: "その他",
    ko: "기타",
    ar: "أخرى",
    hi: "अन्य",
    ru: "Другое",
    tr: "Diğer",
    nl: "Overig",
    pl: "Inne",
    id: "Lainnya",
  },
};

const copy = {
  en: {
    assistantEyebrow: "Project Discovery Assistant",
    assistantTitle: "Interware Project Discovery Assistant",
    stepOf: "Step {current} of {total}",
    stepRequiredError: "Please complete this step before continuing.",
    back: "Back",
    continue: "Continue",
    submitAssessment: "Submit project assessment",
    submitting: "Submitting...",
    initLoading: "Initializing project discovery assistant...",
    technicalScopeLabel: "Technical depth",
    aiDetailLabel: "AI detail",
    detectedCountryPrefix: "We detected you may be contacting us from",
    unknownLocation: "an unknown location",
    useDetectedCountry: "Yes, use",
    chooseAnotherCountry: "No, choose another country",
    internationalProject: "International / multi-region",
    projectCountryLabel: "Project country",
    timezoneLabel: "Timezone",
    selectCountry: "Select country",
    timezonePlaceholder: "America/Toronto",
    investmentCurrency: "Currency",
    businessGoalPlaceholder:
      "We want to improve operational efficiency using AI, modernize an internal platform, and create a mobile experience for our customers.",
    contactNamePlaceholder: "Contact name",
    contactTreatmentPlaceholder: "Title",
    contactRolePlaceholder: "Role",
    companyPlaceholder: "Company",
    workEmailPlaceholder: "Email",
    phonePlaceholder: "Phone / WhatsApp (optional)",
    contactMethodHint: "We will contact you by email, and we may use WhatsApp if you provide a phone number.",
    loadingAntiSpam: "Loading anti-spam verification...",
    summaryOrganization: "Organization",
    summaryIndustry: "Industry",
    summaryRegion: "Region",
    summaryInvestment: "Investment",
    summaryBusinessGoal: "Business goal",
    submittedSuccess: "Project assessment submitted successfully.",
    leadScore: "Lead score",
    priority: "Priority",
    suggestedOffering: "Suggested offering",
    scheduleTitle: "Schedule a discovery call",
    scheduleSubtitle:
      "Authentication is required before scheduling to reduce spam and protect availability.",
    continueApple: "Continue with Apple",
    continueGoogle: "Continue with Google",
    continueMagic: "Continue with email magic link",
    connecting: "Connecting...",
    officialGoogleButton: "Official Google sign-in button",
    googleNotConfigured: "Google sign-in is not configured in this environment.",
    magicTokenPlaceholder: "Paste magic link token",
    verify: "Verify",
    chooseSlot: "Choose an available appointment slot ({timezone})",
    refreshSlots: "Refresh slots",
    noSlots: "No slots available yet.",
    confirmAppointment: "Confirm appointment",
  },
  es: {
    assistantEyebrow: "Asistente de discovery de proyectos",
    assistantTitle: "Asistente de Discovery de Proyectos Interware",
    stepOf: "Paso {current} de {total}",
    stepRequiredError: "Completá este paso antes de continuar.",
    back: "Volver",
    continue: "Continuar",
    submitAssessment: "Enviar evaluación del proyecto",
    submitting: "Enviando...",
    initLoading: "Inicializando asistente de discovery...",
    technicalScopeLabel: "Profundidad técnica",
    aiDetailLabel: "Detalle de IA",
    detectedCountryPrefix: "Detectamos que podrías estar contactando desde",
    unknownLocation: "una ubicación desconocida",
    useDetectedCountry: "Sí, usar",
    chooseAnotherCountry: "No, elegir otro país",
    internationalProject: "Internacional / multi-región",
    projectCountryLabel: "País del proyecto",
    timezoneLabel: "Zona horaria",
    selectCountry: "Seleccionar país",
    timezonePlaceholder: "America/Montevideo",
    investmentCurrency: "Moneda",
    businessGoalPlaceholder:
      "Queremos mejorar la eficiencia operativa con IA, modernizar una plataforma interna y crear una experiencia mobile para nuestros clientes.",
    contactNamePlaceholder: "Nombre de contacto",
    contactTreatmentPlaceholder: "Tratamiento",
    contactRolePlaceholder: "Cargo",
    companyPlaceholder: "Empresa",
    workEmailPlaceholder: "Email",
    phonePlaceholder: "Teléfono / WhatsApp (opcional)",
    contactMethodHint: "Te contactaremos por email y podemos usar WhatsApp si dejás un teléfono.",
    loadingAntiSpam: "Cargando verificación anti-spam...",
    summaryOrganization: "Organización",
    summaryIndustry: "Industria",
    summaryRegion: "Región",
    summaryInvestment: "Inversión",
    summaryBusinessGoal: "Objetivo de negocio",
    submittedSuccess: "Evaluación del proyecto enviada correctamente.",
    leadScore: "Puntaje",
    priority: "Prioridad",
    suggestedOffering: "Oferta sugerida",
    scheduleTitle: "Agendar una llamada de discovery",
    scheduleSubtitle:
      "La autenticación es requerida antes de agendar para reducir spam y proteger la disponibilidad.",
    continueApple: "Continuar con Apple",
    continueGoogle: "Continuar con Google",
    continueMagic: "Continuar con link mágico por email",
    connecting: "Conectando...",
    officialGoogleButton: "Botón oficial de Google",
    googleNotConfigured: "Google Sign-In no está configurado en este entorno.",
    magicTokenPlaceholder: "Pegá el token del link mágico",
    verify: "Verificar",
    chooseSlot: "Elegí un horario disponible ({timezone})",
    refreshSlots: "Actualizar horarios",
    noSlots: "Todavía no hay horarios disponibles.",
    confirmAppointment: "Confirmar cita",
  },
};

const copyOverrides = {
  pt: {
    assistantEyebrow: "Assistente de Discovery de Projetos",
    assistantTitle: "Assistente de Discovery de Projetos Interware",
    stepOf: "Etapa {current} de {total}",
    stepRequiredError: "Conclua esta etapa antes de continuar.",
    back: "Voltar",
    continue: "Continuar",
    submitAssessment: "Enviar avaliação do projeto",
    submitting: "Enviando...",
    initLoading: "Inicializando assistente de discovery...",
    technicalScopeLabel: "Profundidade técnica",
    aiDetailLabel: "Detalhe de IA",
    detectedCountryPrefix: "Detectamos que você pode estar entrando em contato de",
    unknownLocation: "localização desconhecida",
    useDetectedCountry: "Sim, usar",
    chooseAnotherCountry: "Não, escolher outro país",
    internationalProject: "Internacional / multirregional",
    projectCountryLabel: "País do projeto",
    timezoneLabel: "Fuso horário",
    selectCountry: "Selecionar país",
    investmentCurrency: "Moeda",
    contactTreatmentPlaceholder: "Tratamento",
    contactNamePlaceholder: "Nome de contato",
    contactRolePlaceholder: "Cargo",
    companyPlaceholder: "Empresa",
    workEmailPlaceholder: "Email",
    phonePlaceholder: "Telefone / WhatsApp (opcional)",
    contactMethodHint: "Entraremos em contato por email e podemos usar WhatsApp se você informar um telefone.",
    loadingAntiSpam: "Carregando verificação anti-spam...",
    summaryOrganization: "Organização",
    summaryIndustry: "Indústria",
    summaryRegion: "Região",
    summaryInvestment: "Investimento",
    summaryBusinessGoal: "Objetivo de negócio",
    submittedSuccess: "Avaliação do projeto enviada com sucesso.",
    leadScore: "Pontuação",
    priority: "Prioridade",
    suggestedOffering: "Oferta sugerida",
  },
  fr: {
    assistantEyebrow: "Assistant Discovery Projet",
    assistantTitle: "Assistant Discovery de Projet Interware",
    stepOf: "Étape {current} sur {total}",
    stepRequiredError: "Veuillez compléter cette étape avant de continuer.",
    back: "Retour",
    continue: "Continuer",
    submitAssessment: "Envoyer l'évaluation du projet",
    submitting: "Envoi en cours...",
    initLoading: "Initialisation de l'assistant de discovery...",
    technicalScopeLabel: "Profondeur technique",
    aiDetailLabel: "Détail IA",
    detectedCountryPrefix: "Nous avons détecté que vous nous contactez peut-être depuis",
    unknownLocation: "un emplacement inconnu",
    useDetectedCountry: "Oui, utiliser",
    chooseAnotherCountry: "Non, choisir un autre pays",
    internationalProject: "International / multi-région",
    projectCountryLabel: "Pays du projet",
    timezoneLabel: "Fuseau horaire",
    selectCountry: "Sélectionner un pays",
    investmentCurrency: "Devise",
    contactTreatmentPlaceholder: "Civilité",
    contactNamePlaceholder: "Nom du contact",
    contactRolePlaceholder: "Poste",
    companyPlaceholder: "Entreprise",
    workEmailPlaceholder: "Email",
    phonePlaceholder: "Téléphone / WhatsApp (optionnel)",
    contactMethodHint: "Nous vous contacterons par email et nous pourrons utiliser WhatsApp si vous laissez un téléphone.",
    loadingAntiSpam: "Chargement de la vérification anti-spam...",
    summaryOrganization: "Organisation",
    summaryIndustry: "Secteur",
    summaryRegion: "Région",
    summaryInvestment: "Investissement",
    summaryBusinessGoal: "Objectif métier",
    submittedSuccess: "Évaluation du projet envoyée avec succès.",
    leadScore: "Score",
    priority: "Priorité",
    suggestedOffering: "Offre suggérée",
  },
  de: {
    assistantEyebrow: "Projekt-Discovery-Assistent",
    assistantTitle: "Interware Projekt-Discovery-Assistent",
    stepOf: "Schritt {current} von {total}",
    stepRequiredError: "Bitte schließen Sie diesen Schritt ab, bevor Sie fortfahren.",
    back: "Zurück",
    continue: "Weiter",
    submitAssessment: "Projektbewertung senden",
    submitting: "Wird gesendet...",
    initLoading: "Discovery-Assistent wird initialisiert...",
    technicalScopeLabel: "Technische Tiefe",
    aiDetailLabel: "KI-Details",
    detectedCountryPrefix: "Wir haben erkannt, dass Sie uns möglicherweise kontaktieren aus",
    unknownLocation: "einem unbekannten Standort",
    useDetectedCountry: "Ja, verwenden",
    chooseAnotherCountry: "Nein, anderes Land wählen",
    internationalProject: "International / multiregional",
    projectCountryLabel: "Projektland",
    timezoneLabel: "Zeitzone",
    selectCountry: "Land auswählen",
    investmentCurrency: "Währung",
    contactTreatmentPlaceholder: "Anrede",
    contactNamePlaceholder: "Kontaktname",
    contactRolePlaceholder: "Position",
    companyPlaceholder: "Unternehmen",
    workEmailPlaceholder: "E-Mail",
    phonePlaceholder: "Telefon / WhatsApp (optional)",
    contactMethodHint: "Wir kontaktieren Sie per E-Mail und können WhatsApp nutzen, wenn Sie eine Telefonnummer angeben.",
    loadingAntiSpam: "Anti-Spam-Prüfung wird geladen...",
    summaryOrganization: "Organisation",
    summaryIndustry: "Branche",
    summaryRegion: "Region",
    summaryInvestment: "Investition",
    summaryBusinessGoal: "Geschäftsziel",
    submittedSuccess: "Projektbewertung erfolgreich gesendet.",
    leadScore: "Score",
    priority: "Priorität",
    suggestedOffering: "Vorgeschlagenes Angebot",
  },
  it: {
    assistantEyebrow: "Assistente Discovery Progetti",
    assistantTitle: "Assistente Discovery Progetti Interware",
    stepOf: "Passo {current} di {total}",
    stepRequiredError: "Completa questo passaggio prima di continuare.",
    back: "Indietro",
    continue: "Continua",
    submitAssessment: "Invia valutazione progetto",
    submitting: "Invio in corso...",
    initLoading: "Inizializzazione assistente discovery...",
    technicalScopeLabel: "Profondità tecnica",
    aiDetailLabel: "Dettaglio IA",
    detectedCountryPrefix: "Abbiamo rilevato che potresti contattarci da",
    unknownLocation: "una posizione sconosciuta",
    useDetectedCountry: "Sì, usa",
    chooseAnotherCountry: "No, scegli un altro Paese",
    internationalProject: "Internazionale / multi-regione",
    projectCountryLabel: "Paese del progetto",
    timezoneLabel: "Fuso orario",
    selectCountry: "Seleziona Paese",
    investmentCurrency: "Valuta",
    contactTreatmentPlaceholder: "Titolo",
    contactNamePlaceholder: "Nome contatto",
    contactRolePlaceholder: "Ruolo",
    companyPlaceholder: "Azienda",
    workEmailPlaceholder: "Email",
    phonePlaceholder: "Telefono / WhatsApp (opzionale)",
    contactMethodHint: "Ti contatteremo via email e potremo usare WhatsApp se lasci un numero di telefono.",
    loadingAntiSpam: "Caricamento verifica anti-spam...",
    summaryOrganization: "Organizzazione",
    summaryIndustry: "Settore",
    summaryRegion: "Regione",
    summaryInvestment: "Investimento",
    summaryBusinessGoal: "Obiettivo di business",
    submittedSuccess: "Valutazione progetto inviata con successo.",
    leadScore: "Punteggio",
    priority: "Priorità",
    suggestedOffering: "Offerta suggerita",
  },
  zh: {
    assistantEyebrow: "项目 Discovery 助手",
    assistantTitle: "Interware 项目 Discovery 助手",
    stepOf: "第 {current} 步，共 {total} 步",
    stepRequiredError: "请先完成此步骤后再继续。",
    back: "返回",
    continue: "继续",
    submitAssessment: "提交项目评估",
    submitting: "提交中...",
    initLoading: "正在初始化 discovery 助手...",
    technicalScopeLabel: "技术深度",
    aiDetailLabel: "AI 细节",
    detectedCountryPrefix: "我们检测到您可能来自",
    unknownLocation: "未知位置",
    useDetectedCountry: "是，使用",
    chooseAnotherCountry: "否，选择其他国家",
    internationalProject: "国际 / 多区域",
    projectCountryLabel: "项目国家",
    timezoneLabel: "时区",
    selectCountry: "选择国家",
    investmentCurrency: "货币",
    contactTreatmentPlaceholder: "称谓",
    contactNamePlaceholder: "联系人姓名",
    contactRolePlaceholder: "职位",
    companyPlaceholder: "公司",
    workEmailPlaceholder: "邮箱",
    phonePlaceholder: "电话 / WhatsApp（可选）",
    contactMethodHint: "我们将通过邮箱联系您；如果您提供电话，也可以通过 WhatsApp 联系。",
    loadingAntiSpam: "正在加载反垃圾验证...",
    summaryOrganization: "组织",
    summaryIndustry: "行业",
    summaryRegion: "区域",
    summaryInvestment: "投资",
    summaryBusinessGoal: "业务目标",
    submittedSuccess: "项目评估已成功提交。",
    leadScore: "评分",
    priority: "优先级",
    suggestedOffering: "建议服务",
  },
  ja: {
    assistantEyebrow: "プロジェクト Discovery アシスタント",
    assistantTitle: "Interware プロジェクト Discovery アシスタント",
    stepOf: "{total} ステップ中 {current}",
    stepRequiredError: "続行する前にこのステップを完了してください。",
    back: "戻る",
    continue: "続ける",
    submitAssessment: "プロジェクト評価を送信",
    submitting: "送信中...",
    initLoading: "discovery アシスタントを初期化しています...",
    technicalScopeLabel: "技術的深度",
    aiDetailLabel: "AI 詳細",
    detectedCountryPrefix: "現在地の検出結果:",
    unknownLocation: "不明な場所",
    useDetectedCountry: "はい、使用する",
    chooseAnotherCountry: "いいえ、別の国を選ぶ",
    internationalProject: "国際 / マルチリージョン",
    projectCountryLabel: "プロジェクト国",
    timezoneLabel: "タイムゾーン",
    selectCountry: "国を選択",
    investmentCurrency: "通貨",
    contactTreatmentPlaceholder: "敬称",
    contactNamePlaceholder: "担当者名",
    contactRolePlaceholder: "役職",
    companyPlaceholder: "会社名",
    workEmailPlaceholder: "メール",
    phonePlaceholder: "電話 / WhatsApp（任意）",
    contactMethodHint: "基本はメールでご連絡し、電話番号がある場合は WhatsApp も使用します。",
    loadingAntiSpam: "迷惑対策認証を読み込み中...",
    summaryOrganization: "組織",
    summaryIndustry: "業界",
    summaryRegion: "地域",
    summaryInvestment: "投資",
    summaryBusinessGoal: "ビジネス目標",
    submittedSuccess: "プロジェクト評価を送信しました。",
    leadScore: "スコア",
    priority: "優先度",
    suggestedOffering: "提案オファー",
  },
  ko: {
    assistantEyebrow: "프로젝트 Discovery 어시스턴트",
    assistantTitle: "Interware 프로젝트 Discovery 어시스턴트",
    stepOf: "총 {total}단계 중 {current}단계",
    stepRequiredError: "계속하려면 이 단계를 완료해 주세요.",
    back: "뒤로",
    continue: "계속",
    submitAssessment: "프로젝트 평가 제출",
    submitting: "제출 중...",
    initLoading: "discovery 어시스턴트 초기화 중...",
    technicalScopeLabel: "기술 심화 범위",
    aiDetailLabel: "AI 세부사항",
    detectedCountryPrefix: "현재 접속 국가로 감지된 위치:",
    unknownLocation: "알 수 없는 위치",
    useDetectedCountry: "예, 사용",
    chooseAnotherCountry: "아니요, 다른 국가 선택",
    internationalProject: "국제 / 다중 지역",
    projectCountryLabel: "프로젝트 국가",
    timezoneLabel: "시간대",
    selectCountry: "국가 선택",
    investmentCurrency: "통화",
    contactTreatmentPlaceholder: "호칭",
    contactNamePlaceholder: "담당자 이름",
    contactRolePlaceholder: "직책",
    companyPlaceholder: "회사",
    workEmailPlaceholder: "이메일",
    phonePlaceholder: "전화 / WhatsApp (선택)",
    contactMethodHint: "기본적으로 이메일로 연락드리며, 전화번호가 있으면 WhatsApp도 사용할 수 있습니다.",
    loadingAntiSpam: "스팸 방지 인증 불러오는 중...",
    summaryOrganization: "조직",
    summaryIndustry: "산업",
    summaryRegion: "지역",
    summaryInvestment: "투자",
    summaryBusinessGoal: "비즈니스 목표",
    submittedSuccess: "프로젝트 평가가 성공적으로 제출되었습니다.",
    leadScore: "점수",
    priority: "우선순위",
    suggestedOffering: "추천 서비스",
  },
  ar: {
    assistantEyebrow: "مساعد اكتشاف المشاريع",
    assistantTitle: "مساعد اكتشاف مشاريع Interware",
    stepOf: "الخطوة {current} من {total}",
    stepRequiredError: "يرجى إكمال هذه الخطوة قبل المتابعة.",
    back: "رجوع",
    continue: "متابعة",
    submitAssessment: "إرسال تقييم المشروع",
    submitting: "جارٍ الإرسال...",
    initLoading: "جارٍ تهيئة مساعد الاكتشاف...",
    technicalScopeLabel: "العمق التقني",
    aiDetailLabel: "تفاصيل الذكاء الاصطناعي",
    detectedCountryPrefix: "اكتشفنا أنك قد تتواصل معنا من",
    unknownLocation: "موقع غير معروف",
    useDetectedCountry: "نعم، استخدام",
    chooseAnotherCountry: "لا، اختر دولة أخرى",
    internationalProject: "دولي / متعدد المناطق",
    projectCountryLabel: "بلد المشروع",
    timezoneLabel: "المنطقة الزمنية",
    selectCountry: "اختر الدولة",
    investmentCurrency: "العملة",
    contactTreatmentPlaceholder: "اللقب",
    contactNamePlaceholder: "اسم جهة الاتصال",
    contactRolePlaceholder: "المنصب",
    companyPlaceholder: "الشركة",
    workEmailPlaceholder: "البريد الإلكتروني",
    phonePlaceholder: "الهاتف / واتساب (اختياري)",
    contactMethodHint: "سنتواصل معك عبر البريد الإلكتروني، ويمكننا استخدام واتساب إذا أضفت رقم هاتف.",
    loadingAntiSpam: "جارٍ تحميل التحقق من مكافحة الرسائل المزعجة...",
    summaryOrganization: "المؤسسة",
    summaryIndustry: "القطاع",
    summaryRegion: "المنطقة",
    summaryInvestment: "الاستثمار",
    summaryBusinessGoal: "هدف الأعمال",
    submittedSuccess: "تم إرسال تقييم المشروع بنجاح.",
    leadScore: "النتيجة",
    priority: "الأولوية",
    suggestedOffering: "العرض المقترح",
  },
  hi: {
    assistantEyebrow: "प्रोजेक्ट Discovery सहायक",
    assistantTitle: "Interware प्रोजेक्ट Discovery सहायक",
    stepOf: "चरण {current} / {total}",
    stepRequiredError: "कृपया आगे बढ़ने से पहले यह चरण पूरा करें।",
    back: "वापस",
    continue: "जारी रखें",
    submitAssessment: "प्रोजेक्ट मूल्यांकन भेजें",
    submitting: "भेजा जा रहा है...",
    initLoading: "discovery सहायक प्रारंभ किया जा रहा है...",
    technicalScopeLabel: "तकनीकी गहराई",
    aiDetailLabel: "AI विवरण",
    detectedCountryPrefix: "हमें लगा कि आप संपर्क कर रहे हैं",
    unknownLocation: "अज्ञात स्थान",
    useDetectedCountry: "हाँ, उपयोग करें",
    chooseAnotherCountry: "नहीं, दूसरा देश चुनें",
    internationalProject: "अंतरराष्ट्रीय / बहु-क्षेत्रीय",
    projectCountryLabel: "प्रोजेक्ट देश",
    timezoneLabel: "समय क्षेत्र",
    selectCountry: "देश चुनें",
    investmentCurrency: "मुद्रा",
    contactTreatmentPlaceholder: "उपाधि",
    contactNamePlaceholder: "संपर्क नाम",
    contactRolePlaceholder: "पद",
    companyPlaceholder: "कंपनी",
    workEmailPlaceholder: "ईमेल",
    phonePlaceholder: "फोन / व्हाट्सऐप (वैकल्पिक)",
    contactMethodHint: "हम आपसे ईमेल पर संपर्क करेंगे, और फोन देने पर व्हाट्सऐप भी उपयोग कर सकते हैं।",
    loadingAntiSpam: "एंटी-स्पैम सत्यापन लोड हो रहा है...",
    summaryOrganization: "संगठन",
    summaryIndustry: "उद्योग",
    summaryRegion: "क्षेत्र",
    summaryInvestment: "निवेश",
    summaryBusinessGoal: "व्यावसायिक लक्ष्य",
    submittedSuccess: "प्रोजेक्ट मूल्यांकन सफलतापूर्वक भेज दिया गया।",
    leadScore: "स्कोर",
    priority: "प्राथमिकता",
    suggestedOffering: "सुझावित सेवा",
  },
  ru: {
    assistantEyebrow: "Discovery-ассистент проекта",
    assistantTitle: "Discovery-ассистент проектов Interware",
    stepOf: "Шаг {current} из {total}",
    stepRequiredError: "Пожалуйста, заполните этот шаг перед продолжением.",
    back: "Назад",
    continue: "Продолжить",
    submitAssessment: "Отправить оценку проекта",
    submitting: "Отправка...",
    initLoading: "Инициализация discovery-ассистента...",
    technicalScopeLabel: "Техническая глубина",
    aiDetailLabel: "Детали ИИ",
    detectedCountryPrefix: "Мы определили, что вы, возможно, обращаетесь из",
    unknownLocation: "неизвестного местоположения",
    useDetectedCountry: "Да, использовать",
    chooseAnotherCountry: "Нет, выбрать другую страну",
    internationalProject: "Международный / мультирегиональный",
    projectCountryLabel: "Страна проекта",
    timezoneLabel: "Часовой пояс",
    selectCountry: "Выберите страну",
    investmentCurrency: "Валюта",
    contactTreatmentPlaceholder: "Обращение",
    contactNamePlaceholder: "Контактное имя",
    contactRolePlaceholder: "Должность",
    companyPlaceholder: "Компания",
    workEmailPlaceholder: "Email",
    phonePlaceholder: "Телефон / WhatsApp (необязательно)",
    contactMethodHint: "Мы свяжемся с вами по email, а при наличии телефона можем использовать WhatsApp.",
    loadingAntiSpam: "Загрузка антиспам-проверки...",
    summaryOrganization: "Организация",
    summaryIndustry: "Отрасль",
    summaryRegion: "Регион",
    summaryInvestment: "Инвестиции",
    summaryBusinessGoal: "Бизнес-цель",
    submittedSuccess: "Оценка проекта успешно отправлена.",
    leadScore: "Оценка",
    priority: "Приоритет",
    suggestedOffering: "Рекомендуемая услуга",
  },
  tr: {
    assistantEyebrow: "Proje Discovery Asistanı",
    assistantTitle: "Interware Proje Discovery Asistanı",
    stepOf: "Adım {current} / {total}",
    stepRequiredError: "Devam etmeden önce lütfen bu adımı tamamlayın.",
    back: "Geri",
    continue: "Devam",
    submitAssessment: "Proje değerlendirmesini gönder",
    submitting: "Gönderiliyor...",
    initLoading: "Discovery asistanı başlatılıyor...",
    technicalScopeLabel: "Teknik derinlik",
    aiDetailLabel: "YZ detayı",
    detectedCountryPrefix: "Bize şu ülkeden ulaşıyor olabilirsiniz:",
    unknownLocation: "bilinmeyen konum",
    useDetectedCountry: "Evet, kullan",
    chooseAnotherCountry: "Hayır, başka ülke seç",
    internationalProject: "Uluslararası / çok bölgeli",
    projectCountryLabel: "Proje ülkesi",
    timezoneLabel: "Saat dilimi",
    selectCountry: "Ülke seç",
    investmentCurrency: "Para birimi",
    contactTreatmentPlaceholder: "Hitap",
    contactNamePlaceholder: "İletişim adı",
    contactRolePlaceholder: "Pozisyon",
    companyPlaceholder: "Şirket",
    workEmailPlaceholder: "Email",
    phonePlaceholder: "Telefon / WhatsApp (opsiyonel)",
    contactMethodHint: "Sizinle email üzerinden iletişime geçeceğiz; telefon verirseniz WhatsApp da kullanabiliriz.",
    loadingAntiSpam: "Spam koruması doğrulaması yükleniyor...",
    summaryOrganization: "Organizasyon",
    summaryIndustry: "Sektör",
    summaryRegion: "Bölge",
    summaryInvestment: "Yatırım",
    summaryBusinessGoal: "İş hedefi",
    submittedSuccess: "Proje değerlendirmesi başarıyla gönderildi.",
    leadScore: "Puan",
    priority: "Öncelik",
    suggestedOffering: "Önerilen hizmet",
  },
  nl: {
    assistantEyebrow: "Project Discovery Assistent",
    assistantTitle: "Interware Project Discovery Assistent",
    stepOf: "Stap {current} van {total}",
    stepRequiredError: "Vul deze stap in voordat u doorgaat.",
    back: "Terug",
    continue: "Doorgaan",
    submitAssessment: "Projectbeoordeling verzenden",
    submitting: "Verzenden...",
    initLoading: "Discovery-assistent wordt gestart...",
    technicalScopeLabel: "Technische diepgang",
    aiDetailLabel: "AI-detail",
    detectedCountryPrefix: "We hebben gedetecteerd dat u mogelijk contact opneemt vanuit",
    unknownLocation: "een onbekende locatie",
    useDetectedCountry: "Ja, gebruiken",
    chooseAnotherCountry: "Nee, ander land kiezen",
    internationalProject: "Internationaal / multi-regio",
    projectCountryLabel: "Projectland",
    timezoneLabel: "Tijdzone",
    selectCountry: "Selecteer land",
    investmentCurrency: "Valuta",
    contactTreatmentPlaceholder: "Aanhef",
    contactNamePlaceholder: "Naam contactpersoon",
    contactRolePlaceholder: "Functie",
    companyPlaceholder: "Bedrijf",
    workEmailPlaceholder: "Email",
    phonePlaceholder: "Telefoon / WhatsApp (optioneel)",
    contactMethodHint: "We nemen contact met u op via email en kunnen WhatsApp gebruiken als u een telefoonnummer invult.",
    loadingAntiSpam: "Anti-spamverificatie laden...",
    summaryOrganization: "Organisatie",
    summaryIndustry: "Sector",
    summaryRegion: "Regio",
    summaryInvestment: "Investering",
    summaryBusinessGoal: "Zakelijk doel",
    submittedSuccess: "Projectbeoordeling succesvol verzonden.",
    leadScore: "Score",
    priority: "Prioriteit",
    suggestedOffering: "Voorgestelde dienst",
  },
  pl: {
    assistantEyebrow: "Asystent Discovery Projektu",
    assistantTitle: "Asystent Discovery Projektu Interware",
    stepOf: "Krok {current} z {total}",
    stepRequiredError: "Uzupełnij ten krok przed kontynuacją.",
    back: "Wstecz",
    continue: "Kontynuuj",
    submitAssessment: "Wyślij ocenę projektu",
    submitting: "Wysyłanie...",
    initLoading: "Inicjalizacja asystenta discovery...",
    technicalScopeLabel: "Głębokość techniczna",
    aiDetailLabel: "Szczegóły AI",
    detectedCountryPrefix: "Wykryliśmy, że możesz kontaktować się z",
    unknownLocation: "nieznanej lokalizacji",
    useDetectedCountry: "Tak, użyj",
    chooseAnotherCountry: "Nie, wybierz inny kraj",
    internationalProject: "Międzynarodowy / wieloregionalny",
    projectCountryLabel: "Kraj projektu",
    timezoneLabel: "Strefa czasowa",
    selectCountry: "Wybierz kraj",
    investmentCurrency: "Waluta",
    contactTreatmentPlaceholder: "Tytuł",
    contactNamePlaceholder: "Imię i nazwisko kontaktowe",
    contactRolePlaceholder: "Stanowisko",
    companyPlaceholder: "Firma",
    workEmailPlaceholder: "Email",
    phonePlaceholder: "Telefon / WhatsApp (opcjonalnie)",
    contactMethodHint: "Skontaktujemy się z Tobą przez email, a jeśli podasz telefon, możemy użyć WhatsApp.",
    loadingAntiSpam: "Ładowanie weryfikacji antyspamowej...",
    summaryOrganization: "Organizacja",
    summaryIndustry: "Branża",
    summaryRegion: "Region",
    summaryInvestment: "Inwestycja",
    summaryBusinessGoal: "Cel biznesowy",
    submittedSuccess: "Ocena projektu została wysłana pomyślnie.",
    leadScore: "Wynik",
    priority: "Priorytet",
    suggestedOffering: "Sugerowana usługa",
  },
  id: {
    assistantEyebrow: "Asisten Discovery Proyek",
    assistantTitle: "Asisten Discovery Proyek Interware",
    stepOf: "Langkah {current} dari {total}",
    stepRequiredError: "Silakan lengkapi langkah ini sebelum melanjutkan.",
    back: "Kembali",
    continue: "Lanjut",
    submitAssessment: "Kirim evaluasi proyek",
    submitting: "Mengirim...",
    initLoading: "Menginisialisasi asisten discovery...",
    technicalScopeLabel: "Kedalaman teknis",
    aiDetailLabel: "Detail AI",
    detectedCountryPrefix: "Kami mendeteksi Anda mungkin menghubungi dari",
    unknownLocation: "lokasi tidak diketahui",
    useDetectedCountry: "Ya, gunakan",
    chooseAnotherCountry: "Tidak, pilih negara lain",
    internationalProject: "Internasional / multi-wilayah",
    projectCountryLabel: "Negara proyek",
    timezoneLabel: "Zona waktu",
    selectCountry: "Pilih negara",
    investmentCurrency: "Mata uang",
    contactTreatmentPlaceholder: "Sapaan",
    contactNamePlaceholder: "Nama kontak",
    contactRolePlaceholder: "Jabatan",
    companyPlaceholder: "Perusahaan",
    workEmailPlaceholder: "Email",
    phonePlaceholder: "Telepon / WhatsApp (opsional)",
    contactMethodHint: "Kami akan menghubungi Anda via email, dan dapat menggunakan WhatsApp jika Anda mengisi nomor telepon.",
    loadingAntiSpam: "Memuat verifikasi anti-spam...",
    summaryOrganization: "Organisasi",
    summaryIndustry: "Industri",
    summaryRegion: "Wilayah",
    summaryInvestment: "Investasi",
    summaryBusinessGoal: "Tujuan bisnis",
    submittedSuccess: "Evaluasi proyek berhasil dikirim.",
    leadScore: "Skor",
    priority: "Prioritas",
    suggestedOffering: "Layanan yang disarankan",
  },
};

const getLocalizedValue = (source, language) => {
  if (!source) {
    return "";
  }
  return source[language] || source[fallbackLanguage] || "";
};

export const getLocalizedStepMeta = (step, language) => {
  const entry = stepCopy[step.key];
  if (!entry) {
    return step;
  }
  return {
    ...step,
    title: getLocalizedValue(entry.title, language),
    question: getLocalizedValue(entry.question, language),
  };
};

export const getLocalizedOptionLabel = (option, language) => {
  const entry = optionLabels[option];
  if (!entry) {
    return option;
  }
  return entry[language] || entry[fallbackLanguage] || option;
};

export const getLocalizedIndustryGroupLabel = (label, language) => {
  const entry = industryGroupLabels[label];
  if (!entry) {
    return label;
  }
  return entry[language] || entry[fallbackLanguage] || label;
};

export const getDiscoveryCopy = (language) => {
  const base = copy[fallbackLanguage];
  const core = copy[language] || base;
  const overrides = copyOverrides[language] || {};
  return {
    ...base,
    ...core,
    ...overrides,
  };
};
